import {
  ACCOUNTING_PERIODS_CREATE,
  BANK_RECONCILIATIONS_CREATE,
  BANK_RECONCILIATIONS_INDEX,
  BANK_RECONCILIATIONS_UPDATE,
  DOUBTFUL_DEBT_PROVISIONS_INDEX,
  DOUBTFUL_DEBT_PROVISIONS_POST,
  FIXED_ASSETS_CREATE,
  FIXED_ASSETS_INDEX,
  FIXED_ASSETS_UPDATE,
  RECEIVABLE_WRITEOFFS_CREATE,
  RECEIVABLE_WRITEOFFS_INDEX,
  ACCOUNTING_PERIODS_INDEX,
  ACCOUNTING_PERIODS_UPDATE,
  ACTION_LOGS_INDEX,
  DEFERRAL_SCHEDULES_CREATE,
  DEFERRAL_SCHEDULES_INDEX,
  DEFERRAL_SCHEDULES_UPDATE,
  FISCAL_YEAR_CLOSINGS_INDEX,
  OPENING_BALANCES_IMPORT,
  OPENING_BALANCES_INDEX,
  RECURRING_JOURNALS_CREATE,
  RECURRING_JOURNALS_INDEX,
  RECURRING_JOURNALS_UPDATE,
  ADMINS_CREATE,
  ADMINS_EDIT,
  ADMINS_INDEX,
  ADMINS_SHOW,
  ADVERTISEMENTS_INDEX,
  BANKS_INDEX,
  CONTRACTS_CREATE,
  CONTRACTS_EDIT,
  CONTRACTS_INDEX,
  CONTRACTS_SHOW,
  CONTACT_MESSAGES_VIEW,
  CUSTOMERS_CREATE,
  CUSTOMERS_EDIT,
  CUSTOMERS_INDEX,
  CUSTOMERS_SHOW,
  EMPLOYEES_CREATE,
  EMPLOYEES_EDIT,
  EMPLOYEE_CUSTODIES_CREATE,
  EMPLOYEE_CUSTODIES_INDEX,
  EMPLOYEE_CUSTODIES_UPDATE,
  EMPLOYEES_INDEX,
  EMPLOYEES_SHOW,
  SALARIES_INDEX,
  ENTITIES_INDEX,
  ENTITIES_TRADEMARKS_INDEX,
  FINANCIAL_ENTRIES_CREATE,
  FINANCIAL_ENTRIES_EDIT,
  FINANCIAL_ENTRIES_INDEX,
  FINANCIAL_REPORTS_EXECUTIVE_OVERVIEW,
  FINANCIAL_TREES_CREATE,
  FINANCIAL_TREES_EDIT,
  FINANCIAL_TREES_INDEX,
  HOME_INDEX,
  OVERVIEW_PROPERTIES_INDEX,
  OVERVIEW_FINANCE_INDEX,
  OVERVIEW_INVENTORY_INDEX,
  OVERVIEW_MAINTENANCE_INDEX,
  OVERVIEW_CUSTOMERS_INDEX,
  OVERVIEW_DOCUMENTS_INDEX,
  DOCUMENTS_INDEX,
  DOCUMENTS_CREATE,
  DOCUMENTS_UPDATE,
  DOCUMENT_CATEGORIES_INDEX,
  LETTERS_INDEX,
  ESIGN_INDEX,
  ESIGN_CREATE,
  ESIGN_UPDATE,
  LETTERS_CREATE,
  LETTERS_UPDATE,
  LETTERS_MANAGE_TEMPLATES,
  LETTERS_MANAGE_TYPES,
  INVENTORIES_CREATE,
  INVENTORIES_EDIT,
  INVENTORIES_INDEX,
  INVENTORIES_SHOW,
  LEADS_CONTACT_INDEX,
  LEADS_INDEX,
  LEADS_SOURCE_INDEX,
  MAINTENANCE_REQUESTS_INDEX,
  MAINTENANCE_REQUESTS_CREATE,
  MAINTENANCE_REQUESTS_UPDATE,
  MAINTENANCE_SECTIONS_INDEX,
  NOTES_INDEX,
  NOTIFICATION_TEMPLATES_INDEX,
  POS_CREATE,
  POS_INDEX,
  POS_UPDATE,
  ROLES_CREATE,
  ROLES_EDIT,
  ROLES_INDEX,
  ROLES_SHOW,
  SALES_CONTRACTS_CREATE,
  SALES_CONTRACTS_INDEX,
  SALES_CONTRACTS_UPDATE,
  SANADAT_CREATE,
  SANADAT_INDEX,
  SANADAT_SHOW,
  SERVICES_INDEX,
  SITE_VISITS_INDEX,
  SITE_VISITS_SETTINGS_INDEX,
  APPOINTMENT_BOOKINGS_INDEX,
  SERVICE_REQUESTS_INDEX,
  SPARE_PARTS_REQUESTS_INDEX,
  SUBSCRIPTIONS_INDEX,
  SUPPORT_CENTER_TICKETS_INDEX,
  SUPPORT_CENTER_TICKETS_SHOW,
  TASKS_INDEX,
  TASKS_SHOW,
  TAXES_CREATE,
  TAXES_INDEX,
  TAXES_UPDATE,
  UNITS_CREATE,
  UNITS_EDIT,
  UNITS_INDEX,
  UNITS_SHOW,
  VOUCHERS_DESTRUCTION_INDEX,
  VOUCHERS_RETURN_INDEX,
  VOUCHERS_SUPPLY_INDEX,
  VOUCHERS_TRANSFER_INDEX,
  VOUCHERS_WITHDRAW_INDEX,
  VOUCHERS_WITHDRAW_CREATE,
  VOUCHERS_RETURN_CREATE,
  VOUCHERS_SUPPLY_CREATE,
  VOUCHERS_DESTRUCTION_CREATE,
  VOUCHERS_TRANSFER_CREATE,
  CONTRACTS_CONDITIONS_TEMPLATES_LIST,
  CONTRACTS_CONDITIONS_TEMPLATES_CREATE,
  CONTRACTS_CONDITIONS_TEMPLATES_UPDATE,
  SALES_CONTRACTS_SHOW,
  EMPLOYEES_POSITIONS_INDEX,
  DEPARTMENTS_INDEX,
  INVENTORY_QUANTITY_TYPES_INDEX,
  INVENTORY_CATEGORIES_INDEX,
  SALES_INVOICES_INDEX,
  SALES_INVOICES_SHOW,
  CREDIT_NOTE_INDEX,
  CREDIT_NOTE_SHOW,
  CREDIT_NOTE_CREATE,
  PURCHASE_INVOICES_INDEX,
  PURCHASE_INVOICES_CREATE,
  DEBIT_NOTE_INDEX,
  DEBIT_NOTE_SHOW,
  DEBIT_NOTE_CREATE,
  RPO_INDEX,
  PRICE_QUOTATIONS_INDEX,
  PRICE_QUOTATIONS_SHOW,
  PRICE_QUOTATIONS_CREATE,
  PRICE_QUOTATIONS_UPDATE,
  END_OF_SERVICES_INDEX,
  END_OF_SERVICES_CREATE,
  END_OF_SERVICES_UPDATE,
  PAYROLL_RUNS_INDEX,
  PAYROLL_RUNS_CREATE,
  PAYROLL_RUNS_UPDATE,
  ATTENDANCE_INDEX,
  WORK_SHIFTS_INDEX,
  LEAVES_INDEX,
  LEAVE_TYPES_INDEX,
  EMPLOYEE_LOANS_INDEX,
  HR_REPORTS_PAYROLL_REGISTER,
  HR_REPORTS_GOSI_CONTRIBUTIONS,
  HR_REPORTS_END_OF_SERVICE_LIABILITY,
  HR_REPORTS_ATTENDANCE_SUMMARY,
  HR_REPORTS_LEAVE_BALANCES,
  HR_REPORTS_LOANS_OUTSTANDING,
  HR_REPORTS_EMPLOYEE_STATEMENT,
  SERVICE_CONTRACTS_INDEX,
  BOOKING_CONTRACT_VIEW,
  BOOKING_CONTRACT_CREATE,
  BOOKING_CONTRACT_UPDATE,
  EJAR_PLATFORM_CONTRACTS_INDEX,
  SERVICE_CONTRACTS_SHOW,
  SERVICE_CONTRACTS_CREATE,
  SERVICE_CONTRACTS_UPDATE,
  SALES_REPORTS_QUOTATIONS_REGISTER,
  SALES_REPORTS_QUOTATION_CONVERSION,
  SALES_REPORTS_INVOICE_ANALYSIS,
  RPO_CREATE,
  PO_INDEX,
  PO_CREATE,
  PROPERTIES_CREATE,
  PROPERTIES_EDIT,
  PROPERTIES_SHOW,
  PROPERTIES_SMART_REPORTS,
  PROJECTS_CREATE,
  PROJECTS_UPDATE,
  PROJECTS_SHOW,
  UNIT_MESSAGES_INDEX,
  WAREHOUSES_ASSETS_INDEX,
  WAREHOUSES_EQUIPMENTS_INDEX,
  WAREHOUSES_SPAREPARTS_INDEX,
  WAREHOUSES_POS_INDEX,
  WORK_ORDERS_INDEX,
  UNIT_INVESTMENT_SUMMARY,
  UNIT_PARTIES_STORE,
  UNIT_PARTIES_UPDATE,
  UNIT_PARTIES_SHOW,
  SALES_INVOICES_CREATE,
  LEADS_SHOW,
  LEADS_STORE,
  LEADS_UPDATE,
  AGENT_OPTIONS_INDEX,
  DATA_MIGRATION_INDEX,
  LEADS_INTERACTIONS_STORE,
  LEADS_DEALS_INDEX,
  LEADS_INTERACTIONS_INDEX,
  LEADS_FAVOURITES_INDEX,
  DEALS_SHOW,
  DEALS_STORE,
  DEALS_UPDATE,
  CRM_COMPANIES_INDEX,
  CRM_TEAMS_INDEX,
  REMINDERS_INDEX,
  WORK_ORDERS_VIEW,
  MAINTENANCE_REVIEWS_INDEX,
  MAINTENANCE_INPUTS_READINGS_INDEX,
  WALLET_INDEX,
  WALLET_SETTINGS,
} from "permissions";

// `breadcrumb` places a page in the trail at the top of the page
// (components/shared/breadcrumbs). A page the sidebar links to without a query
// string needs none: the sidebar names it and its groups. Every other page —
// including one the sidebar reaches only through queries, like `customers` — declares
//   label  — an i18n key; `{{id}}` and the other route params interpolate
//   parent — the `path` of the page one level up, written exactly as declared
//            here; a query string after it is kept on the parent's link
// e.g. { label: "breadcrumbs.edit", parent: "customers/:id" }.

//////////////// Banks ////////////////
const banksRoutes = [
  {
    path: "banks",
    filePath: "modules/banks/components/index",
    isModule: true,
    permissionId: BANKS_INDEX,
  },
];

//////////////// Contracts ////////////////
const contractsRoutes = [
  {
    path: "contracts",
    filePath: "modules/contracts/components/index",
    isModule: true,
    permissionId: CONTRACTS_INDEX,
  },
  {
    path: "contracts/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "contracts" },
    filePath: "modules/contracts/components/add-contract/index",
    isModule: true,
    createPermissionId: CONTRACTS_CREATE,
    editPermissionId: CONTRACTS_EDIT,
  },
  {
    path: "contracts/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "rent-contracts/:id" },
    filePath: "modules/contracts/components/add-contract/index",
    isModule: true,
    createPermissionId: CONTRACTS_CREATE,
    editPermissionId: CONTRACTS_EDIT,
  },
  {
    path: "add-contract-unit/:unit_id",
    breadcrumb: { label: "breadcrumbs.new", parent: "contracts" },
    filePath: "modules/contracts/components/add-contract/index",
    isModule: true,
    createPermissionId: CONTRACTS_CREATE,
    editPermissionId: CONTRACTS_EDIT,
  },
  {
    path: "contracts-conditions",
    filePath: "modules/contracts/components/conditions/index",
    isModule: true,
    permissionId: CONTRACTS_CONDITIONS_TEMPLATES_LIST,
  },
  {
    path: "add-condition",
    breadcrumb: { label: "breadcrumbs.new", parent: "contracts-conditions" },
    filePath: "modules/contracts/components/conditions/add",
    isModule: true,
    permissionId: CONTRACTS_CONDITIONS_TEMPLATES_CREATE,
  },
  {
    path: "add-condition/:id",
    breadcrumb: { label: "breadcrumbs.edit", parent: "contracts-conditions" },
    filePath: "modules/contracts/components/conditions/add",
    isModule: true,
    permissionId: CONTRACTS_CONDITIONS_TEMPLATES_UPDATE,
  },
  {
    path: "sales-contracts",
    filePath: "modules/contracts/components/sales-contracts/index",
    isModule: true,
    permissionId: SALES_CONTRACTS_INDEX,
  },
  {
    path: "sales-contracts/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "sales-contracts" },
    filePath: "modules/contracts/components/sales-contracts/add/index",
    isModule: true,
    createPermissionId: SALES_CONTRACTS_CREATE,
    editPermissionId: SALES_CONTRACTS_UPDATE,
  },
  {
    path: "add-sale-contract-unit/:unit_id",
    breadcrumb: { label: "breadcrumbs.new", parent: "sales-contracts" },
    filePath: "modules/contracts/components/sales-contracts/add/index",
    isModule: true,
    createPermissionId: SALES_CONTRACTS_CREATE,
    editPermissionId: SALES_CONTRACTS_UPDATE,
  },
  {
    path: "sales-contracts/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "sales-contracts/:id" },
    filePath: "modules/contracts/components/sales-contracts/add/index",
    isModule: true,
    createPermissionId: SALES_CONTRACTS_CREATE,
    editPermissionId: SALES_CONTRACTS_UPDATE,
  },
  {
    path: "rent-contracts/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "contracts" },
    filePath: "modules/contracts/components/profile/index",
    isModule: true,
    permissionId: CONTRACTS_SHOW,
  },
  {
    path: "sales-contracts/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "sales-contracts" },
    filePath: "modules/contracts/components/sales-contracts/profile/index",
    isModule: true,
    permissionId: SALES_CONTRACTS_SHOW,
  },
];

//////////////// Customers ////////////////
const customersRoutes = [
  {
    path: "customers",
    breadcrumb: { label: "pages.customers" },
    filePath: "modules/customers/components/index",
    isModule: true,
    permissionId: CUSTOMERS_INDEX,
  },
  {
    path: "customers/new",
    breadcrumb: {
      label: "breadcrumbs.new",
      parent: "customers?customer_type=individual",
    },
    filePath: "modules/customers/components/add-customer/index",
    isModule: true,
    createPermissionId: CUSTOMERS_CREATE,
    editPermissionId: CUSTOMERS_EDIT,
  },
  {
    path: "customers/new/:customer_type",
    breadcrumb: {
      label: "breadcrumbs.new",
      parent: "customers?customer_type=individual",
    },
    filePath: "modules/customers/components/add-customer/index",
    isModule: true,
    createPermissionId: CUSTOMERS_CREATE,
    editPermissionId: CUSTOMERS_EDIT,
  },
  {
    path: "customers/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "customers/:id" },
    filePath: "modules/customers/components/add-customer/index",
    isModule: true,
    createPermissionId: CUSTOMERS_CREATE,
    editPermissionId: CUSTOMERS_EDIT,
  },
  {
    path: "customers/:id",
    breadcrumb: {
      label: "breadcrumbs.record",
      parent: "customers?customer_type=individual",
    },
    filePath: "modules/customers/components/customer-profile/index",
    isModule: true,
    permissionId: CUSTOMERS_SHOW,
  },
];

//////////////// Employees ////////////////
const employeesRoutes = [
  {
    path: "employees",
    filePath: "modules/employees/components/index",
    isModule: true,
    permissionId: EMPLOYEES_INDEX,
  },
  {
    path: "employees/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "employees" },
    filePath: "modules/employees/components/add-employee/index",
    isModule: true,
    createPermissionId: EMPLOYEES_CREATE,
    editPermissionId: EMPLOYEES_EDIT,
  },
  {
    path: "employees/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "employees/:id" },
    filePath: "modules/employees/components/add-employee/index",
    isModule: true,
    createPermissionId: EMPLOYEES_CREATE,
    editPermissionId: EMPLOYEES_EDIT,
  },
  {
    path: "employees/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "employees" },
    filePath: "modules/employees/components/employee-profile/index",
    isModule: true,
    permissionId: EMPLOYEES_SHOW,
  },
  {
    path: "employee-custodies",
    filePath: "modules/employee-custody/components/index",
    isModule: true,
    permissionId: EMPLOYEE_CUSTODIES_INDEX,
  },
  {
    path: "employee-custodies/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "employee-custodies" },
    filePath: "modules/employee-custody/components/add-custody/index",
    isModule: true,
    permissionId: EMPLOYEE_CUSTODIES_CREATE,
  },
  {
    path: "employee-custodies/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "employee-custodies" },
    filePath: "modules/employee-custody/components/custody-view/index",
    isModule: true,
    permissionId: EMPLOYEE_CUSTODIES_INDEX,
  },
  {
    path: "employee-custodies/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "employee-custodies/:id" },
    filePath: "modules/employee-custody/components/add-custody/index",
    isModule: true,
    permissionId: EMPLOYEE_CUSTODIES_UPDATE,
  },
  {
    // A filtered view of the employee register, so it is gated on the register's
    // own key rather than one of its own — as `/almost-expire-identities` is.
    path: "employee-contracts",
    filePath: "modules/employee-contracts/components/index",
    isModule: true,
    permissionId: EMPLOYEES_INDEX,
  },
  {
    path: "employee-positions",
    filePath: "modules/employees/components/employee-positions/index",
    isModule: true,
    permissionId: EMPLOYEES_POSITIONS_INDEX,
  },
  {
    path: "departments",
    filePath: "modules/departments/components/index",
    isModule: true,
    permissionId: DEPARTMENTS_INDEX,
  },
  {
    path: "payouts",
    breadcrumb: { label: "employees.salary.title" },
    filePath: "modules/employees/components/payouts/index",
    isModule: true,
    permissionId: SALARIES_INDEX,
  },
];

//////////////// Entities ////////////////
const entitiesRoutes = [
  {
    path: "entities",
    filePath: "modules/entities/components/index",
    isModule: true,
    permissionId: ENTITIES_INDEX,
  },
  {
    path: "entities-trademarks",
    filePath: "modules/entities/components/entities-trademarks/index",
    isModule: true,
    permissionId: ENTITIES_TRADEMARKS_INDEX,
  },
];

//////////////// Financial ////////////////
const financialRoutes = [
  {
    path: "financial-entries/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "financial-entries" },
    filePath:
      "modules/financial/components/financial-entries/components/add/index",
    isModule: true,
    createPermissionId: FINANCIAL_ENTRIES_CREATE,
    editPermissionId: FINANCIAL_ENTRIES_EDIT,
  },
  {
    path: "financial-entries/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "financial-entries" },
    filePath:
      "modules/financial/components/financial-entries/components/add/index",
    isModule: true,
    createPermissionId: FINANCIAL_ENTRIES_CREATE,
    editPermissionId: FINANCIAL_ENTRIES_EDIT,
  },
  {
    path: "financial-entries",
    filePath: "modules/financial/components/financial-entries/components/index",
    isModule: true,
    permissionId: FINANCIAL_ENTRIES_INDEX,
  },
  {
    path: "financial-trees",
    filePath: "modules/financial-trees/components/index",
    isModule: true,
    permissionId: FINANCIAL_TREES_INDEX,
  },
  {
    path: "financial-trees/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "financial-trees" },
    filePath: "modules/financial-trees/components/add/index",
    isModule: true,
    createPermissionId: FINANCIAL_TREES_CREATE,
    editPermissionId: FINANCIAL_TREES_EDIT,
  },
  {
    path: "financial-trees/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "financial-trees" },
    filePath: "modules/financial-trees/components/add/index",
    isModule: true,
    createPermissionId: FINANCIAL_TREES_CREATE,
    editPermissionId: FINANCIAL_TREES_EDIT,
  },
];

//////////////// Inventory ////////////////
const inventory_voucher_types = [
  "withdraw",
  "return",
  "supply",
  "destruction",
  "transfer",
];

const INVENTORY_VOUCHER_CREATE_PERMISSION = {
  withdraw: VOUCHERS_WITHDRAW_CREATE,
  return: VOUCHERS_RETURN_CREATE,
  supply: VOUCHERS_SUPPLY_CREATE,
  destruction: VOUCHERS_DESTRUCTION_CREATE,
  transfer: VOUCHERS_TRANSFER_CREATE,
};
const INVENTORY_VOUCHER_INDEX_PERMISSION = {
  withdraw: VOUCHERS_WITHDRAW_INDEX,
  return: VOUCHERS_RETURN_INDEX,
  supply: VOUCHERS_SUPPLY_INDEX,
  destruction: VOUCHERS_DESTRUCTION_INDEX,
  transfer: VOUCHERS_TRANSFER_INDEX,
};
const inventoryVoucherAddRoutes = inventory_voucher_types.map((v) => ({
  path: `inventory-vouchers/${v}/add`,
  breadcrumb: { label: "breadcrumbs.new", parent: `inventory-vouchers/${v}` },
  filePath: `modules/inventory/components/inventory-vouchers/${v}/add/index`,
  isModule: true,
  permissionId: INVENTORY_VOUCHER_CREATE_PERMISSION[v],
}));
const inventoryVoucherListRoutes = inventory_voucher_types.map((v) => ({
  path: `inventory-vouchers/${v}`,
  filePath: `modules/inventory/components/inventory-vouchers/${v}/index`,
  isModule: true,
  permissionId: INVENTORY_VOUCHER_INDEX_PERMISSION[v],
}));
// A voucher's page under its own type's list, so the sidebar keeps that list's group open.
// `voucher/:id` below stays for links that do not know the voucher's type.
const inventoryVoucherViewRoutes = inventory_voucher_types.map((v) => ({
  path: `inventory-vouchers/${v}/:id`,
  breadcrumb: {
    label: "breadcrumbs.record",
    parent: `inventory-vouchers/${v}`,
  },
  filePath:
    "modules/inventory/components/inventory-vouchers/voucher-view/index",
  isModule: true,
  permissionId: INVENTORY_VOUCHER_INDEX_PERMISSION[v],
}));

const inventoryRoutes = [
  {
    path: "products",
    filePath: "modules/inventory/components/index",
    isModule: true,
    permissionId: INVENTORIES_INDEX,
  },
  {
    path: "products/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "products" },
    filePath: "modules/inventory/components/inventory-profile/index",
    isModule: true,
    permissionId: INVENTORIES_SHOW,
  },
  {
    // Same products `inventories.index` already lists, viewed by what is on hand —
    // so it gates on that key rather than a second one of its own.
    path: "stock-levels",
    filePath: "modules/inventory/components/stock-levels/index",
    isModule: true,
    permissionId: INVENTORIES_INDEX,
  },
  {
    path: "products/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "products/:id" },
    filePath: "modules/inventory/components/add-inventory/index",
    isModule: true,
    createPermissionId: INVENTORIES_CREATE,
    editPermissionId: INVENTORIES_EDIT,
  },
  {
    path: "products/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "products" },
    filePath: "modules/inventory/components/add-inventory/index",
    isModule: true,
    createPermissionId: INVENTORIES_CREATE,
    editPermissionId: INVENTORIES_EDIT,
  },
  {
    path: "inventory-types",
    filePath: "modules/inventory/components/inventory-types/index",
    isModule: true,
    permissionId: INVENTORY_QUANTITY_TYPES_INDEX,
  },
  {
    path: "inventory-categories",
    filePath: "modules/inventory/components/inventory-categories/index",
    isModule: true,
    permissionId: INVENTORY_CATEGORIES_INDEX,
  },
  {
    path: "inventory/warehouse-exchange-permission",
    breadcrumb: { label: "exchange_permission.title" },
    filePath:
      "modules/inventory/components/warehouse-exchange-permission/index",
    isModule: true,
  },
  {
    path: "voucher/:id",
    breadcrumb: { label: "breadcrumbs.record" },
    filePath:
      "modules/inventory/components/inventory-vouchers/voucher-view/index",
    isModule: true,
  },
  ...inventoryVoucherAddRoutes,
  ...inventoryVoucherListRoutes,
  ...inventoryVoucherViewRoutes,
];

//////////////// Invoices (Modules) ////////////////
const invoicesRoutes = [
  {
    path: "sales-invoices",
    filePath: "modules/invoices/components/ListSalesInvoices",
    isModule: true,
    permissionId: SALES_INVOICES_INDEX,
  },
  {
    path: "sales-invoices/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "sales-invoices" },
    filePath: "modules/invoices/components/ViewSalesInvoice",
    isModule: true,
    permissionId: SALES_INVOICES_SHOW,
  },
  {
    path: "sales-invoices/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "sales-invoices" },
    filePath: "modules/invoices/components/AddSalesInvoices",
    isModule: true,
    permissionId: SALES_INVOICES_CREATE,
  },
  {
    path: "credit-notes",
    filePath: "modules/invoices/components/ListCreditNotes",
    isModule: true,
    permissionId: CREDIT_NOTE_INDEX,
  },
  {
    path: "credit-notes/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "credit-notes" },
    filePath: "modules/invoices/components/AddSalesInvoices",
    isModule: true,
    permissionId: CREDIT_NOTE_CREATE,
  },
  {
    path: "credit-notes/new/:id",
    breadcrumb: { label: "breadcrumbs.new", parent: "credit-notes" },
    filePath: "modules/invoices/components/AddCreditNote",
    isModule: true,
    permissionId: CREDIT_NOTE_CREATE,
  },
  {
    path: "credit-notes/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "credit-notes" },
    filePath: "modules/invoices/components/ViewSalesInvoice",
    isModule: true,
    permissionId: CREDIT_NOTE_SHOW,
  },
  {
    path: "purchase-invoices",
    filePath: "modules/invoices/components/ListPurchaseInvoices",
    isModule: true,
    permissionId: PURCHASE_INVOICES_INDEX,
  },
  {
    path: "purchase-invoices/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "purchase-invoices" },
    filePath: "modules/invoices/components/ViewPurchaseInvoice",
    isModule: true,
    permissionId: PURCHASE_INVOICES_INDEX,
  },
  {
    path: "purchase-invoices/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "purchase-invoices" },
    filePath: "modules/invoices/components/AddPurchaseInvoices",
    isModule: true,
    permissionId: PURCHASE_INVOICES_CREATE,
  },
  {
    path: "debit-notes",
    filePath: "modules/invoices/components/ListDebitNotes",
    isModule: true,
    permissionId: DEBIT_NOTE_INDEX,
  },
  {
    path: "debit-notes/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "debit-notes" },
    filePath: "modules/invoices/components/AddPurchaseInvoices",
    isModule: true,
    permissionId: DEBIT_NOTE_CREATE,
  },
  {
    path: "debit-notes/new/:id",
    breadcrumb: { label: "breadcrumbs.new", parent: "debit-notes" },
    filePath: "modules/invoices/components/AddDebitNote",
    isModule: true,
    permissionId: DEBIT_NOTE_CREATE,
  },
  {
    path: "debit-notes/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "debit-notes" },
    filePath: "modules/invoices/components/ViewPurchaseInvoice",
    isModule: true,
    permissionId: DEBIT_NOTE_SHOW,
  },
  {
    path: "rpos",
    filePath: "modules/invoices/components/ListRpos",
    isModule: true,
    permissionId: RPO_INDEX,
  },
  {
    path: "rpos/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "rpos" },
    filePath: "modules/invoices/components/AddRpo",
    isModule: true,
    permissionId: RPO_CREATE,
  },
  {
    path: "rpos/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "rpos" },
    filePath: "modules/invoices/components/ViewRpo",
    isModule: true,
    permissionId: RPO_INDEX,
  },
  {
    path: "purchase-orders",
    filePath: "modules/invoices/components/ListPurchaseOrders",
    isModule: true,
    permissionId: PO_INDEX,
  },
  {
    path: "purchase-orders/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "purchase-orders" },
    filePath: "modules/invoices/components/AddPurchaseOrder",
    isModule: true,
    permissionId: PO_CREATE,
  },
  {
    path: "purchase-orders/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "purchase-orders" },
    filePath: "modules/invoices/components/ViewPurchaseOrder",
    isModule: true,
    permissionId: PO_INDEX,
  },
];

//////////////// Price Quotations ////////////////
const priceQuotationsRoutes = [
  {
    path: "price-quotations",
    filePath: "modules/price-quotations/components/index",
    isModule: true,
    permissionId: PRICE_QUOTATIONS_INDEX,
  },
  {
    path: "price-quotations/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "price-quotations" },
    filePath: "modules/price-quotations/components/add-price-quotation/index",
    isModule: true,
    createPermissionId: PRICE_QUOTATIONS_CREATE,
    editPermissionId: PRICE_QUOTATIONS_UPDATE,
  },
  {
    path: "price-quotations/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "price-quotations/:id" },
    filePath: "modules/price-quotations/components/add-price-quotation/index",
    isModule: true,
    createPermissionId: PRICE_QUOTATIONS_CREATE,
    editPermissionId: PRICE_QUOTATIONS_UPDATE,
  },
  {
    path: "price-quotations/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "price-quotations" },
    filePath: "modules/price-quotations/components/price-quotation-view/index",
    isModule: true,
    permissionId: PRICE_QUOTATIONS_SHOW,
  },
];

//////////////// Service Contracts ////////////////
const serviceContractsRoutes = [
  {
    path: "service-contracts",
    filePath: "modules/service-contracts/components/index",
    isModule: true,
    permissionId: SERVICE_CONTRACTS_INDEX,
  },
  {
    path: "service-contracts/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "service-contracts" },
    filePath: "modules/service-contracts/components/add-service-contract/index",
    isModule: true,
    createPermissionId: SERVICE_CONTRACTS_CREATE,
    editPermissionId: SERVICE_CONTRACTS_UPDATE,
  },
  {
    path: "service-contracts/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "service-contracts/:id" },
    filePath: "modules/service-contracts/components/add-service-contract/index",
    isModule: true,
    createPermissionId: SERVICE_CONTRACTS_CREATE,
    editPermissionId: SERVICE_CONTRACTS_UPDATE,
  },
  {
    path: "service-contracts/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "service-contracts" },
    filePath:
      "modules/service-contracts/components/service-contract-view/index",
    isModule: true,
    permissionId: SERVICE_CONTRACTS_SHOW,
  },
];

//////////////// Payroll ////////////////
const payrollRoutes = [
  {
    path: "payroll-runs",
    filePath: "modules/payroll/components/index",
    isModule: true,
    permissionId: PAYROLL_RUNS_INDEX,
  },
  {
    path: "payroll-runs/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "payroll-runs" },
    filePath: "modules/payroll/components/add-payroll-run/index",
    isModule: true,
    createPermissionId: PAYROLL_RUNS_CREATE,
    editPermissionId: PAYROLL_RUNS_UPDATE,
  },
  {
    path: "payroll-runs/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "payroll-runs/:id" },
    filePath: "modules/payroll/components/add-payroll-run/index",
    isModule: true,
    createPermissionId: PAYROLL_RUNS_CREATE,
    editPermissionId: PAYROLL_RUNS_UPDATE,
  },
  {
    // Declared after /new so the router does not read "new" as an id.
    path: "payroll-runs/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "payroll-runs" },
    filePath: "modules/payroll/components/payroll-run-view/index",
    isModule: true,
    permissionId: PAYROLL_RUNS_INDEX,
  },
];

//////////////// End of Service ////////////////
const endOfServiceRoutes = [
  {
    path: "end-of-services",
    filePath: "modules/end-of-service/components/index",
    isModule: true,
    permissionId: END_OF_SERVICES_INDEX,
  },
  {
    path: "end-of-services/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "end-of-services" },
    filePath: "modules/end-of-service/components/add-end-of-service/index",
    isModule: true,
    createPermissionId: END_OF_SERVICES_CREATE,
    editPermissionId: END_OF_SERVICES_UPDATE,
  },
  {
    path: "end-of-services/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "end-of-services/:id" },
    filePath: "modules/end-of-service/components/add-end-of-service/index",
    isModule: true,
    createPermissionId: END_OF_SERVICES_CREATE,
    editPermissionId: END_OF_SERVICES_UPDATE,
  },
  {
    // After /new so the router does not read "new" as an id.
    path: "end-of-services/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "end-of-services" },
    filePath: "modules/end-of-service/components/end-of-service-view/index",
    isModule: true,
    permissionId: END_OF_SERVICES_INDEX,
  },
];

//////////////// Attendance, Shifts and Leave ////////////////
const attendanceRoutes = [
  {
    path: "attendance",
    filePath: "modules/attendance/components/index",
    isModule: true,
    permissionId: ATTENDANCE_INDEX,
  },
  {
    // A sibling of /attendance rather than a child: the sidebar's isPathActive
    // counts a nested path as a match on its parent, so /attendance/shifts
    // would light both leaves at once. Same shape as the API.
    path: "work-shifts",
    filePath: "modules/attendance/components/work-shifts/index",
    isModule: true,
    permissionId: WORK_SHIFTS_INDEX,
  },
  {
    path: "leaves",
    filePath: "modules/leaves/components/index",
    isModule: true,
    permissionId: LEAVES_INDEX,
  },
  {
    path: "leave-types",
    filePath: "modules/leaves/components/leave-types/index",
    isModule: true,
    permissionId: LEAVE_TYPES_INDEX,
  },
  {
    path: "employee-loans",
    filePath: "modules/employee-loans/components/index",
    isModule: true,
    permissionId: EMPLOYEE_LOANS_INDEX,
  },
  {
    path: "employee-loans/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "employee-loans" },
    filePath: "modules/employee-loans/components/loan-view/index",
    isModule: true,
    permissionId: EMPLOYEE_LOANS_INDEX,
  },
];

//////////////// HR Reports ////////////////
const hrReportsRoutes = [
  {
    path: "reports/hr",
    filePath: "modules/reports/components/hr/index",
    isModule: true,
    // The hub itself lists only what the reader may open, so the gate is the
    // first report rather than a permission of its own.
    permissionId: HR_REPORTS_PAYROLL_REGISTER,
  },
  {
    path: "reports/hr/payroll-register",
    breadcrumb: {
      label: "hr_reports.payroll_register.title",
      parent: "reports/hr",
    },
    filePath: "modules/reports/components/hr/payroll-register/index",
    isModule: true,
    permissionId: HR_REPORTS_PAYROLL_REGISTER,
  },
  {
    path: "reports/hr/gosi-contributions",
    breadcrumb: { label: "hr_reports.gosi.title", parent: "reports/hr" },
    filePath: "modules/reports/components/hr/gosi-contributions/index",
    isModule: true,
    permissionId: HR_REPORTS_GOSI_CONTRIBUTIONS,
  },
  {
    path: "reports/hr/end-of-service-liability",
    breadcrumb: { label: "hr_reports.eos.title", parent: "reports/hr" },
    filePath: "modules/reports/components/hr/end-of-service-liability/index",
    isModule: true,
    permissionId: HR_REPORTS_END_OF_SERVICE_LIABILITY,
  },
  {
    path: "reports/hr/attendance-summary",
    breadcrumb: { label: "hr_reports.attendance.title", parent: "reports/hr" },
    filePath: "modules/reports/components/hr/attendance-summary/index",
    isModule: true,
    permissionId: HR_REPORTS_ATTENDANCE_SUMMARY,
  },
  {
    path: "reports/hr/leave-balances",
    breadcrumb: { label: "hr_reports.leave.title", parent: "reports/hr" },
    filePath: "modules/reports/components/hr/leave-balances/index",
    isModule: true,
    permissionId: HR_REPORTS_LEAVE_BALANCES,
  },
  {
    path: "reports/hr/loans-outstanding",
    breadcrumb: { label: "hr_reports.loans.title", parent: "reports/hr" },
    filePath: "modules/reports/components/hr/loans-outstanding/index",
    isModule: true,
    permissionId: HR_REPORTS_LOANS_OUTSTANDING,
  },
  {
    path: "reports/hr/employee-statement",
    breadcrumb: {
      label: "hr_reports.employee_statement.title",
      parent: "reports/hr",
    },
    filePath: "modules/reports/components/hr/employee-statement/index",
    isModule: true,
    permissionId: HR_REPORTS_EMPLOYEE_STATEMENT,
  },
];

//////////////// Booking Contracts ////////////////
const bookingContractsRoutes = [
  {
    path: "booking-contracts",
    filePath: "modules/booking-contracts/components/index",
    isModule: true,
    permissionId: BOOKING_CONTRACT_VIEW,
  },
  {
    path: "booking-contracts/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "booking-contracts" },
    filePath: "modules/booking-contracts/components/add-booking-contract/index",
    isModule: true,
    createPermissionId: BOOKING_CONTRACT_CREATE,
    editPermissionId: BOOKING_CONTRACT_UPDATE,
  },
  {
    path: "booking-contracts/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "booking-contracts/:id" },
    filePath: "modules/booking-contracts/components/add-booking-contract/index",
    isModule: true,
    createPermissionId: BOOKING_CONTRACT_CREATE,
    editPermissionId: BOOKING_CONTRACT_UPDATE,
  },
  {
    path: "booking-contracts/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "booking-contracts" },
    filePath:
      "modules/booking-contracts/components/booking-contract-view/index",
    isModule: true,
    // `BOOKING_CONTRACT_VIEW`, not a `*_SHOW` of its own: the backend deliberately has no
    // `booking_contract.show` key — a detail route is guarded by its module's index.
    permissionId: BOOKING_CONTRACT_VIEW,
  },
  {
    // A **sibling** path, not `booking-contracts/day-sheet`. It was split out because the
    // sidebar's `isPathActive` prefix-match would have lit both leaves at once; the day
    // sheet's leaf has since gone (it is a link in the register's header instead), but the
    // path stays here — it mirrors the API, where `/day-sheet` is declared before `/{id}`
    // so the literal segment wins, and moving it now would only break existing links.
    path: "booking-day-sheet",
    breadcrumb: {
      label: "bookingContracts.daySheet.pageTitle",
      parent: "booking-contracts",
    },
    filePath: "modules/booking-contracts/components/day-sheet/index",
    isModule: true,
    // The same key the endpoint carries: the sheet is a filtered read of booking
    // contracts, not a capability of its own.
    permissionId: BOOKING_CONTRACT_VIEW,
  },
];

//////////////// Ejar Contracts ////////////////
// A sibling of `contracts`, not `contracts/ejar-contracts`: the sidebar's
// `isPathActive` prefix-matches `basePath + "/"`, so a nested path would light
// the rent-contracts leaf and this one at the same time.
const ejarContractsRoutes = [
  {
    path: "ejar-contracts",
    filePath: "modules/ejar-contracts/components/index",
    isModule: true,
    permissionId: EJAR_PLATFORM_CONTRACTS_INDEX,
  },
];

//////////////// Document Control ////////////////
const documentsRoutes = [
  {
    path: "documents",
    filePath: "modules/documents/components/index",
    isModule: true,
    permissionId: DOCUMENTS_INDEX,
  },
  {
    // A sibling of `documents`, deliberately not `documents/categories`: the
    // sidebar's `isPathActive` prefix-matches `basePath + "/"`, so a nested path
    // highlighted the register leaf and this one at the same time.
    path: "document-categories",
    filePath: "modules/documents/components/categories/index",
    isModule: true,
    permissionId: DOCUMENT_CATEGORIES_INDEX,
  },
  {
    path: "documents/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "documents" },
    filePath: "modules/documents/components/add-document/index",
    isModule: true,
    createPermissionId: DOCUMENTS_CREATE,
    editPermissionId: DOCUMENTS_UPDATE,
  },
  {
    path: "documents/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "documents/:id" },
    filePath: "modules/documents/components/add-document/index",
    isModule: true,
    createPermissionId: DOCUMENTS_CREATE,
    editPermissionId: DOCUMENTS_UPDATE,
  },
  {
    // Guarded by the register's `index`, not a `.show` key — whoever can list the
    // register can open a row in it, which is the rule the API's route uses too.
    path: "documents/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "documents" },
    filePath: "modules/documents/components/document-view/index",
    isModule: true,
    permissionId: DOCUMENTS_INDEX,
  },
];

//////////////// Electronic Signature ////////////////
const esignRoutes = [
  {
    path: "esign-requests",
    filePath: "modules/esign/components/index",
    isModule: true,
    permissionId: ESIGN_INDEX,
  },
  {
    path: "esign-requests/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "esign-requests" },
    filePath: "modules/esign/components/add-esign-request/index",
    isModule: true,
    createPermissionId: ESIGN_CREATE,
    editPermissionId: ESIGN_UPDATE,
  },
  {
    path: "esign-requests/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "esign-requests/:id" },
    filePath: "modules/esign/components/add-esign-request/index",
    isModule: true,
    createPermissionId: ESIGN_CREATE,
    editPermissionId: ESIGN_UPDATE,
  },
  {
    // Guarded by the register's `index`, not a `.show` key — whoever can list
    // the register can open a row in it, the rule the API's route uses too.
    path: "esign-requests/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "esign-requests" },
    filePath: "modules/esign/components/esign-request-view/index",
    isModule: true,
    permissionId: ESIGN_INDEX,
  },
];

//////////////// Letters ////////////////
const lettersRoutes = [
  {
    path: "letters",
    filePath: "modules/letters/components/index",
    isModule: true,
    permissionId: LETTERS_INDEX,
  },
  {
    path: "letters/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "letters" },
    filePath: "modules/letters/components/add-letter/index",
    isModule: true,
    createPermissionId: LETTERS_CREATE,
    editPermissionId: LETTERS_UPDATE,
  },
  {
    path: "letters/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "letters/:id" },
    filePath: "modules/letters/components/add-letter/index",
    isModule: true,
    createPermissionId: LETTERS_CREATE,
    editPermissionId: LETTERS_UPDATE,
  },
  {
    // Guarded by the register's `index`, not a `.show` key — whoever can list
    // the register can open a row in it, the rule the API's route uses too.
    path: "letters/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "letters" },
    filePath: "modules/letters/components/letter-view/index",
    isModule: true,
    permissionId: LETTERS_INDEX,
  },
  {
    // Siblings of `letters`, deliberately not nested under it: the sidebar's
    // isPathActive prefix-matches basePath + "/", so a nested path would light
    // two leaves at once (the document-categories precedent).
    path: "letter-templates",
    filePath: "modules/letters/components/templates/index",
    isModule: true,
    permissionId: LETTERS_MANAGE_TEMPLATES,
  },
  {
    path: "letter-templates/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "letter-templates" },
    filePath: "modules/letters/components/templates/add-template/index",
    isModule: true,
    permissionId: LETTERS_MANAGE_TEMPLATES,
  },
  {
    path: "letter-templates/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "letter-templates" },
    filePath: "modules/letters/components/templates/add-template/index",
    isModule: true,
    permissionId: LETTERS_MANAGE_TEMPLATES,
  },
  {
    path: "letter-types",
    filePath: "modules/letters/components/types/index",
    isModule: true,
    permissionId: LETTERS_MANAGE_TYPES,
  },
];

//////////////// Maintenance ////////////////
const maintenanceRoutes = [
  {
    path: "maintenance/requests",
    filePath: "modules/maintenance/components/requests/index",
    isModule: true,
    permissionId: MAINTENANCE_REQUESTS_INDEX,
  },
  {
    path: "maintenance/requests/add",
    breadcrumb: { label: "breadcrumbs.new", parent: "maintenance/requests" },
    filePath: "modules/maintenance/components/requests/add/index",
    isModule: true,
    createPermissionId: MAINTENANCE_REQUESTS_CREATE,
    editPermissionId: MAINTENANCE_REQUESTS_UPDATE,
  },
  {
    path: "maintenance/requests/:id/edit",
    breadcrumb: {
      label: "breadcrumbs.edit",
      parent: "maintenance/requests/:id",
    },
    filePath: "modules/maintenance/components/requests/add/index",
    isModule: true,
    createPermissionId: MAINTENANCE_REQUESTS_CREATE,
    editPermissionId: MAINTENANCE_REQUESTS_UPDATE,
  },
  {
    path: "maintenance/requests/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "maintenance/requests" },
    filePath: "modules/maintenance/components/request-view/index",
    isModule: true,
    permissionId: MAINTENANCE_REQUESTS_INDEX,
  },
  {
    path: "maintenance/work-orders",
    filePath: "modules/maintenance/components/work-orders/index",
    isModule: true,
    permissionId: WORK_ORDERS_INDEX,
  },
  {
    path: "maintenance/work-orders/:id",
    breadcrumb: {
      label: "breadcrumbs.record",
      parent: "maintenance/work-orders",
    },
    filePath: "modules/maintenance/components/work-order-view/index",
    isModule: true,
    permissionId: WORK_ORDERS_VIEW,
  },
  {
    path: "maintenance/technicians-workload",
    filePath: "modules/maintenance/components/technicians-workload/index",
    isModule: true,
    permissionId: WORK_ORDERS_INDEX,
  },
  {
    path: "maintenance/assign-technician/:id",
    breadcrumb: {
      label: "maintenance.assign.calendar",
      parent: "maintenance/requests/:id",
    },
    filePath: "modules/maintenance/components/assign-technician/index",
    isModule: true,
    permissionId: WORK_ORDERS_INDEX,
  },
  {
    path: "maintenance/sections",
    filePath: "modules/maintenance/components/sections/index",
    isModule: true,
    permissionId: MAINTENANCE_SECTIONS_INDEX,
  },
  {
    path: "maintenance/reviews",
    filePath: "modules/maintenance/components/reviews/index",
    isModule: true,
    permissionId: MAINTENANCE_REVIEWS_INDEX,
  },
  {
    path: "maintenance/inputs-readings",
    filePath: "modules/maintenance/components/inputs-readings/index",
    isModule: true,
    permissionId: MAINTENANCE_INPUTS_READINGS_INDEX,
  },
];

//////////////// CRM ////////////////
const crmRoutes = [
  {
    path: "crm/potential-customers",
    filePath: "modules/crm/components/potential-customers/index",
    isModule: true,
    permissionId: LEADS_INDEX,
  },
  {
    path: "crm/potential-customers/:id",
    breadcrumb: {
      label: "breadcrumbs.record",
      parent: "crm/potential-customers",
    },
    filePath: "modules/crm/components/potential-customers-profile/index",
    isModule: true,
    permissionId: LEADS_SHOW,
  },
  {
    path: "crm/add-potential-customer",
    breadcrumb: { label: "breadcrumbs.new", parent: "crm/potential-customers" },
    filePath: "modules/crm/components/add-potential-customer/index",
    isModule: true,
    permissionId: LEADS_STORE,
  },
  {
    path: "crm/add-potential-customer/:id",
    breadcrumb: {
      label: "breadcrumbs.edit",
      parent: "crm/potential-customers/:id",
    },
    filePath: "modules/crm/components/add-potential-customer/index",
    isModule: true,
    permissionId: LEADS_UPDATE,
  },
  {
    path: "crm/contacts",
    filePath: "modules/crm/components/contacts/index",
    isModule: true,
    permissionId: LEADS_CONTACT_INDEX,
  },
  {
    path: "leads-sources",
    filePath: "modules/crm/components/leads-sources/index",
    isModule: true,
    permissionId: LEADS_SOURCE_INDEX,
  },
  {
    path: "deals",
    filePath: "modules/crm/components/deals/index",
    isModule: true,
    permissionId: LEADS_DEALS_INDEX,
  },
  {
    path: "crm/deals/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "deals" },
    filePath: "modules/crm/components/deal-view/index",
    isModule: true,
    permissionId: DEALS_SHOW,
  },
  {
    path: "crm/add-deal",
    breadcrumb: { label: "breadcrumbs.new", parent: "deals" },
    filePath: "modules/crm/components/add-deal/index",
    isModule: true,
    permissionId: DEALS_STORE,
  },
  {
    path: "crm/add-deal/:id",
    breadcrumb: { label: "breadcrumbs.edit", parent: "crm/deals/:id" },
    filePath: "modules/crm/components/add-deal/index",
    isModule: true,
    permissionId: DEALS_UPDATE,
  },
  {
    path: "crm/companies",
    filePath: "modules/crm/components/companies/index",
    isModule: true,
    permissionId: CRM_COMPANIES_INDEX,
  },
  {
    path: "crm/teams",
    filePath: "modules/crm/components/teams/index",
    isModule: true,
    permissionId: CRM_TEAMS_INDEX,
  },
  {
    // The sales agent's own home. `skipPermissionGate` mirrors the endpoint, which carries
    // no permission middleware for the same reason: an agent must never be locked out of
    // their own dashboard. Each zone inside is gated by the module permission behind it —
    // the API returns null for a section the caller cannot read.
    path: "crm/my-dashboard",
    filePath: "modules/crm/components/sales-home/index",
    isModule: true,
    skipPermissionGate: true,
  },
  {
    path: "reminders",
    filePath: "modules/crm/components/reminders/index",
    isModule: true,
    permissionId: REMINDERS_INDEX,
  },
  {
    path: "favourites",
    filePath: "modules/crm/components/favourites/index",
    isModule: true,
    permissionId: LEADS_FAVOURITES_INDEX,
  },
  {
    path: "interactions",
    filePath: "modules/crm/components/interactions/index",
    isModule: true,
    permissionId: LEADS_INTERACTIONS_INDEX,
  },
];

//////////////// Properties ////////////////
const propertiesRoutes = [
  {
    path: "add-property/:type_id",
    breadcrumb: {
      label: "breadcrumbs.newProperty",
      parent: "units-and-properties?view=property",
    },
    filePath: "modules/properties/components/add-property/index",
    isModule: true,
    permissionId: PROPERTIES_CREATE,
  },
  {
    path: "properties/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "properties/:id" },
    filePath: "modules/properties/components/add-property/index",
    isModule: true,
    permissionId: PROPERTIES_EDIT,
  },
  {
    path: "properties/:id",
    breadcrumb: {
      label: "breadcrumbs.record",
      parent: "units-and-properties?view=property",
    },
    filePath: "modules/properties/components/property-profile/index",
    isModule: true,
    permissionId: PROPERTIES_SHOW,
  },
  {
    path: "properties/:id/smart-reports/:report",
    breadcrumb: { label: "smartReports.title", parent: "properties/:id" },
    filePath: "modules/properties/components/smart-report-view/index",
    isModule: true,
    permissionId: PROPERTIES_SMART_REPORTS,
  },
];

//////////////// Projects ////////////////
const projectsRoutes = [
  {
    path: "add-project",
    breadcrumb: {
      label: "breadcrumbs.newProject",
      parent: "units-and-properties?view=project",
    },
    filePath: "modules/projects/components/add-project/index",
    isModule: true,
    permissionId: PROJECTS_CREATE,
  },
  {
    path: "add-project/:type_id",
    breadcrumb: {
      label: "breadcrumbs.newProject",
      parent: "units-and-properties?view=project",
    },
    filePath: "modules/projects/components/add-project/index",
    isModule: true,
    permissionId: PROJECTS_CREATE,
  },
  {
    path: "projects/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "projects/:id" },
    filePath: "modules/projects/components/add-project/index",
    isModule: true,
    permissionId: PROJECTS_UPDATE,
  },
  {
    path: "projects/:id",
    breadcrumb: {
      label: "breadcrumbs.record",
      parent: "units-and-properties?view=project",
    },
    filePath: "modules/projects/components/project-profile/index",
    isModule: true,
    permissionId: PROJECTS_SHOW,
  },
];

//////////////// Units ////////////////
const unitsRoutes = [
  {
    path: "units-details",
    breadcrumb: { label: "breadcrumbs.unitsDetails" },
    filePath: "modules/units/components/index",
    isModule: true,
    permissionId: UNITS_INDEX,
  },
  {
    // No segment: a unit is created as a unit type, and the property type follows from the
    // property it is put in. `add-unit/:property_type` stays for the links that do know one —
    // the "add unit" button on a property's own profile.
    path: "add-unit",
    breadcrumb: {
      label: "breadcrumbs.newUnit",
      parent: "units-and-properties?view=unit",
    },
    filePath: "modules/units/components/add-unit/index",
    isModule: true,
    permissionId: UNITS_CREATE,
  },
  {
    path: "add-unit/:property_type",
    breadcrumb: {
      label: "breadcrumbs.newUnit",
      parent: "units-and-properties?view=unit",
    },
    filePath: "modules/units/components/add-unit/index",
    isModule: true,
    permissionId: UNITS_CREATE,
  },
  {
    path: "units/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "units/:id" },
    filePath: "modules/units/components/add-unit/index",
    isModule: true,
    permissionId: UNITS_EDIT,
  },
  {
    path: "units/:id",
    breadcrumb: {
      label: "breadcrumbs.record",
      parent: "units-and-properties?view=unit",
    },
    filePath: "modules/units/components/unit-profile/index",
    isModule: true,
    permissionId: UNITS_SHOW,
  },
  {
    path: "units-messages",
    filePath: "modules/units/components/units-messages/index",
    isModule: true,
    permissionId: UNIT_MESSAGES_INDEX,
  },
  {
    path: "units-messages/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "units-messages" },
    filePath: "modules/units/components/units-messages/conversation-view",
    isModule: true,
    permissionId: UNIT_MESSAGES_INDEX,
  },
  {
    path: "units-and-properties",
    filePath: "modules/units/components/units-and-properties/index",
    isModule: true,
  },
];

//////////////// Roles ////////////////
const rolesRoutes = [
  {
    path: "admin/roles",
    filePath: "modules/roles/components/index",
    isModule: true,
    permissionId: ROLES_INDEX,
  },
  {
    path: "admin/roles/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "admin/roles" },
    filePath: "modules/roles/components/add-role/index",
    isModule: true,
    createPermissionId: ROLES_CREATE,
    editPermissionId: ROLES_EDIT,
  },
  {
    path: "admin/roles/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "admin/roles/:id/view" },
    filePath: "modules/roles/components/add-role/index",
    isModule: true,
    createPermissionId: ROLES_CREATE,
    editPermissionId: ROLES_EDIT,
  },
  {
    path: "admin/roles/:id/view",
    breadcrumb: { label: "breadcrumbs.record", parent: "admin/roles" },
    filePath: "modules/roles/components/view-role/index",
    isModule: true,
    permissionId: ROLES_SHOW,
  },
];

//////////////// Sanadat / Vouchers ////////////////
const sanadatRoutes = [
  {
    path: "vouchers",
    filePath: "modules/sanadat/components/index",
    isModule: true,
    permissionId: SANADAT_INDEX,
  },
  {
    path: "vouchers/new",
    breadcrumb: { label: "add_sanad", parent: "vouchers" },
    filePath: "modules/sanadat/components/add-sanadat/index",
    isModule: true,
    permissionId: SANADAT_CREATE,
  },
  {
    path: "vouchers/catch/new",
    breadcrumb: { label: "add_receipt_sanad", parent: "vouchers" },
    filePath: "modules/sanadat/components/add-catch-sanadat/index",
    isModule: true,
    permissionId: SANADAT_CREATE,
  },
  {
    path: "vouchers/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "vouchers" },
    filePath: "modules/sanadat/components/profile/index",
    isModule: true,
    permissionId: SANADAT_SHOW,
  },
];

//////////////// Services ////////////////
const servicesRoutes = [
  {
    path: "services",
    filePath: "modules/services/components/index",
    isModule: true,
    permissionId: SERVICES_INDEX,
  },
];
//////////////// Settings ////////////////
const settingsRoutes = [
  {
    path: "settings",
    filePath: "modules/settings/components/index",
    isModule: true,
    permissionId: AGENT_OPTIONS_INDEX,
  },
  // One page per tab; `:tab` is the tab's `SETTINGS_TAB_PATHS` segment. The page
  // names its crumb after the tab and checks the tab's own permission.
  {
    path: "settings/:tab",
    breadcrumb: { label: "pages.settings", parent: "settings" },
    filePath: "modules/settings/components/settings-tab/index",
    isModule: true,
    permissionId: AGENT_OPTIONS_INDEX,
  },
  // Data Migration is a hub of tools rather than one panel, so it has a page
  // of its own (outranking `settings/:tab`) and each tool a page under it.
  {
    path: "settings/data-migration",
    breadcrumb: { label: "settingsSidebar.dataMigration", parent: "settings" },
    filePath: "modules/settings/components/data-migration/index",
    isModule: true,
    permissionId: DATA_MIGRATION_INDEX,
  },
  {
    path: "settings/data-migration/:tool",
    breadcrumb: {
      label: "settingsSidebar.dataMigration",
      parent: "settings/data-migration",
    },
    filePath: "modules/settings/components/data-migration/ToolPage",
    isModule: true,
    permissionId: DATA_MIGRATION_INDEX,
  },
];

//////////////// Notification Templates ////////////////
const notificationTemplatesRoutes = [
  {
    path: "notification-templates",
    filePath: "modules/notifications/components/index",
    isModule: true,
    permissionId: NOTIFICATION_TEMPLATES_INDEX,
  },
];

//////////////// Notifications Center ////////////////
// The current user's own notifications inbox. Not permission-gated — mirrors the
// top-bar bell, which every authenticated agent user can open.
const notificationsRoutes = [
  {
    path: "notifications",
    breadcrumb: { label: "notificationsCenter.title" },
    filePath: "modules/topbar/components/all-notifications/index",
    isModule: true,
    skipPermissionGate: true,
  },
];

//////////////// Support ////////////////
const supportRoutes = [
  {
    path: "support-center",
    filePath: "modules/support/components/support-center/index",
    isModule: true,
    permissionId: SUPPORT_CENTER_TICKETS_INDEX,
  },
  {
    path: "support-details/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "support-center" },
    filePath: "modules/support/components/support-details/index",
    isModule: true,
    permissionId: SUPPORT_CENTER_TICKETS_SHOW,
  },
  {
    path: "contact-messages",
    filePath: "modules/support/components/contact-messages/index",
    isModule: true,
    permissionId: CONTACT_MESSAGES_VIEW,
  },
];

//////////////// User activity log ////////////////
// Read-only: entries are written by the backend request pipeline, so there is no
// create/edit route and `action_logs.index` is the module's only permission.
const actionLogsRoutes = [
  {
    path: "action-logs",
    filePath: "modules/action-logs/components/index",
    isModule: true,
    permissionId: ACTION_LOGS_INDEX,
  },
];

//////////////// Amer Support (tenant ↔ central helpdesk) ////////////////
// Universal support channel to the Amer central team — available to every
// authenticated tenant user (its data lives in central, not gated by a tenant
// permission row), so the routes skip the permission gate.
const amerSupportRoutes = [
  {
    path: "amer-support",
    breadcrumb: { label: "amerSupport.title" },
    filePath: "modules/amer-support/components/index",
    isModule: true,
    skipPermissionGate: true,
  },
  {
    path: "amer-support/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "amer-support" },
    filePath: "modules/amer-support/components/add-ticket/index",
    isModule: true,
    skipPermissionGate: true,
  },
  {
    path: "amer-support/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "amer-support" },
    filePath: "modules/amer-support/components/ticket-details/index",
    isModule: true,
    skipPermissionGate: true,
  },
];

// Platform news published centrally by the Amer team and read by every
// authenticated tenant user — its data lives in central, not behind a tenant
// permission row, so the routes skip the permission gate (like amer-support).
const announcementsRoutes = [
  {
    path: "announcements",
    breadcrumb: { label: "announcements.title" },
    filePath: "modules/announcements/components/index",
    isModule: true,
    skipPermissionGate: true,
  },
  {
    path: "announcements/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "announcements" },
    filePath: "modules/announcements/components/announcement-view/index",
    isModule: true,
    skipPermissionGate: true,
  },
];

//////////////// Advertisements ////////////////
const advertisementsRoutes = [
  {
    path: "advertisements",
    filePath: "modules/advertisements/components/index",
    isModule: true,
    permissionId: ADVERTISEMENTS_INDEX,
  },
];

//////////////// Taxes ////////////////
const taxesRoutes = [
  {
    path: "taxes",
    filePath: "modules/taxes/components/index",
    isModule: true,
    permissionId: TAXES_INDEX,
  },
  {
    path: "taxes/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "taxes" },
    filePath: "modules/taxes/components/add/index",
    isModule: true,
    createPermissionId: TAXES_CREATE,
    editPermissionId: TAXES_UPDATE,
  },
  {
    path: "taxes/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "taxes" },
    filePath: "modules/taxes/components/add/index",
    isModule: true,
    createPermissionId: TAXES_CREATE,
    editPermissionId: TAXES_UPDATE,
  },
];

//////////////// stock-withdraw-requests ////////////////
const stockWithdrawRequestsRoutes = [
  {
    path: "stock-withdraw-requests",
    filePath: "modules/stock-withdraw-requests/components/index",
    isModule: true,
    permissionId: WAREHOUSES_ASSETS_INDEX,
  },
];

//////////////// Warehouses ////////////////
const warehousesRoutes = [
  {
    path: "warehouses/assets",
    filePath: "modules/warehouses/components/assets/index",
    isModule: true,
    permissionId: WAREHOUSES_ASSETS_INDEX,
  },
  {
    path: "warehouses/equipments",
    filePath: "modules/warehouses/components/equipments/index",
    isModule: true,
    permissionId: WAREHOUSES_EQUIPMENTS_INDEX,
  },
  {
    path: "warehouses/spareparts",
    filePath: "modules/warehouses/components/spareparts/index",
    isModule: true,
    permissionId: WAREHOUSES_SPAREPARTS_INDEX,
  },
  {
    path: "warehouses/pos",
    filePath: "modules/warehouses/components/pos/index",
    isModule: true,
    permissionId: WAREHOUSES_POS_INDEX,
  },
];

//////////////// POS ////////////////
const posRoutes = [
  {
    path: "pos",
    filePath: "modules/pos/components/index",
    isModule: true,
    permissionId: POS_INDEX,
  },
  {
    path: "pos/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "pos" },
    filePath: "modules/pos/components/form/index",
    isModule: true,
    createPermissionId: POS_CREATE,
    editPermissionId: POS_UPDATE,
  },
  {
    path: "pos/:id",
    breadcrumb: { label: "breadcrumbs.edit", parent: "pos" },
    filePath: "modules/pos/components/form/index",
    isModule: true,
    createPermissionId: POS_CREATE,
    editPermissionId: POS_UPDATE,
  },
];

//////////////// Tasks ////////////////
const tasksRoutes = [
  {
    path: "tasks",
    breadcrumb: { label: "pages.tasks" },
    filePath: "modules/tasks/components/index",
    isModule: true,
    permissionId: TASKS_INDEX,
  },
  {
    path: "task/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "tasks" },
    filePath: "modules/tasks/components/task/index",
    isModule: true,
    permissionId: TASKS_SHOW,
  },
];

//////////////// Notes ////////////////
const notesRoutes = [
  {
    path: "notes",
    breadcrumb: { label: "pages.notes" },
    filePath: "modules/notes/components/index",
    isModule: true,
    permissionId: NOTES_INDEX,
  },
];

//////////////// Orders ////////////////
const ordersRoutes = [
  {
    path: "orders",
    breadcrumb: { label: "pages.orders" },
    filePath: "modules/orders/components/index",
    isModule: true,
    permissionId: WORK_ORDERS_INDEX,
  },
];

//////////////// Reports ////////////////
const reportsRoutes = [
  {
    path: "reports/financial",
    filePath: "modules/reports/components/financial/index",
    isModule: true,
  },
  {
    path: "reports/financial/trial-balance",
    breadcrumb: {
      label: "financial_reports.trial_balance",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/trial-balance/index",
    isModule: true,
  },
  {
    path: "reports/financial/balance-sheet",
    breadcrumb: {
      label: "financial_reports.balance_sheet",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/balance-sheet/index",
    isModule: true,
  },
  {
    path: "reports/financial/income-statement",
    breadcrumb: {
      label: "financial_reports.income_statement",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/income-statement/index",
    isModule: true,
  },
  {
    path: "reports/financial/cash-flow",
    breadcrumb: {
      label: "financial_reports.cash_flow",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/cash-flow/index",
    isModule: true,
  },
  {
    path: "reports/financial/cash-flow-direct",
    breadcrumb: {
      label: "financial_reports.cash_flow_direct",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/cash-flow-direct/index",
    isModule: true,
  },
  {
    path: "reports/financial/cash-forecast",
    breadcrumb: {
      label: "financial_reports.cash_forecast",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/cash-forecast/index",
    isModule: true,
  },
  {
    path: "reports/financial/management-pack",
    breadcrumb: {
      label: "financial_reports.management_pack",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/management-pack/index",
    isModule: true,
  },
  {
    path: "reports/financial/bank-reconciliation",
    breadcrumb: {
      label: "financial_reports.bank_reconciliation",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/bank-reconciliation/index",
    isModule: true,
  },
  {
    path: "reports/financial/general-ledger",
    breadcrumb: {
      label: "financial_reports.general_ledger",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/general-ledger/index",
    isModule: true,
  },
  {
    path: "reports/financial/account-ledger",
    breadcrumb: {
      label: "financial_reports.account_ledger",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/account-ledger/index",
    isModule: true,
  },
  {
    path: "reports/financial/sub-ledger",
    breadcrumb: {
      label: "financial_reports.sub_ledger",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/sub-ledger/index",
    isModule: true,
  },
  {
    path: "reports/financial/cost-center-pl",
    breadcrumb: {
      label: "financial_reports.cost_center_pl",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/cost-center-pl/index",
    isModule: true,
  },
  {
    path: "reports/financial/depreciation-schedule",
    breadcrumb: {
      label: "financial_reports.depreciation_schedule",
      parent: "reports/financial",
    },
    filePath:
      "modules/reports/components/financial/depreciation-schedule/index",
    isModule: true,
  },
  {
    path: "reports/financial/settlement-aging",
    breadcrumb: {
      label: "financial_reports.settlement_aging",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/settlement-aging/index",
    isModule: true,
  },
  {
    path: "reports/financial/vat-return",
    breadcrumb: {
      label: "financial_reports.vat_return",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/vat-return/index",
    isModule: true,
  },
  {
    path: "reports/financial/vat-detailed",
    breadcrumb: {
      label: "financial_reports.vat_detailed",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/vat-detailed/index",
    isModule: true,
  },
  {
    path: "reports/inventory-reports",
    filePath: "modules/reports/components/inventory-reports/index",
    isModule: true,
  },
  // Finance close & control reports. No permissionId, matching the other 69 report
  // routes: the hub card gates visibility and the endpoint gates the data.
  {
    path: "reports/financial/subledger-reconciliation",
    breadcrumb: {
      label: "financial_reports.subledger_reconciliation",
      parent: "reports/financial",
    },
    filePath:
      "modules/reports/components/financial/subledger-reconciliation/index",
    isModule: true,
  },
  {
    path: "reports/financial/control-account-reconciliation",
    breadcrumb: {
      label: "financial_reports.control_account_reconciliation",
      parent: "reports/financial",
    },
    filePath:
      "modules/reports/components/financial/control-account-reconciliation/index",
    isModule: true,
  },
  {
    path: "reports/financial/proof-of-cash",
    breadcrumb: {
      label: "financial_reports.proof_of_cash",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/proof-of-cash/index",
    isModule: true,
  },
  {
    path: "reports/financial/segment",
    breadcrumb: {
      label: "financial_reports.segment_report",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/segment/index",
    isModule: true,
  },
  {
    path: "reports/financial/related-party",
    breadcrumb: {
      label: "financial_reports.related_party",
      parent: "reports/financial",
    },
    filePath: "modules/reports/components/financial/related-party/index",
    isModule: true,
  },
  {
    path: "reports/inventory-reports/gl-reconciliation",
    breadcrumb: {
      label: "inventory_reports.gl_reconciliation",
      parent: "reports/inventory-reports",
    },
    filePath:
      "modules/reports/components/inventory-reports/gl-reconciliation/index",
    isModule: true,
  },
  {
    path: "reports/inventory-reports/stock-on-hand",
    breadcrumb: {
      label: "inventory_reports.stock_on_hand",
      parent: "reports/inventory-reports",
    },
    filePath:
      "modules/reports/components/inventory-reports/stock-on-hand/index",
    isModule: true,
  },
  {
    path: "reports/inventory-reports/movement-ledger",
    breadcrumb: {
      label: "inventory_reports.movement_ledger",
      parent: "reports/inventory-reports",
    },
    filePath:
      "modules/reports/components/inventory-reports/movement-ledger/index",
    isModule: true,
  },
  {
    path: "reports/inventory-reports/monthly-summary",
    breadcrumb: {
      label: "inventory_reports.monthly_summary",
      parent: "reports/inventory-reports",
    },
    filePath:
      "modules/reports/components/inventory-reports/monthly-summary/index",
    isModule: true,
  },
  {
    path: "reports/inventory-reports/aged-stock",
    breadcrumb: {
      label: "inventory_reports.aged_stock",
      parent: "reports/inventory-reports",
    },
    filePath: "modules/reports/components/inventory-reports/aged-stock/index",
    isModule: true,
  },
  {
    path: "reports/inventory-reports/vouchers-register",
    breadcrumb: {
      label: "inventory_reports.vouchers_register",
      parent: "reports/inventory-reports",
    },
    filePath:
      "modules/reports/components/inventory-reports/vouchers-register/index",
    isModule: true,
  },
  {
    path: "reports/inventory-reports/valuation-by-category",
    breadcrumb: {
      label: "inventory_reports.valuation_by_category",
      parent: "reports/inventory-reports",
    },
    filePath:
      "modules/reports/components/inventory-reports/valuation-by-category/index",
    isModule: true,
  },
  {
    path: "reports/customer-dues",
    filePath: "modules/reports/components/customer-dues/index",
    isModule: true,
  },
  {
    path: "reports/customer-dues/ar-aging",
    breadcrumb: {
      label: "financial_reports.ar_aging",
      parent: "reports/customer-dues",
    },
    filePath: "modules/reports/components/financial/ar-aging/index",
    isModule: true,
  },
  {
    path: "reports/customer-dues/collections-performance",
    breadcrumb: {
      label: "customer_dues_reports.collections_performance",
      parent: "reports/customer-dues",
    },
    filePath:
      "modules/reports/components/customer-dues/collections-performance/index",
    isModule: true,
  },
  {
    path: "reports/customer-dues/cashflow-forecast",
    breadcrumb: {
      label: "customer_dues_reports.cashflow_forecast",
      parent: "reports/customer-dues",
    },
    filePath:
      "modules/reports/components/customer-dues/cashflow-forecast/index",
    isModule: true,
  },
  {
    path: "reports/customer-dues/statement",
    breadcrumb: {
      label: "customer_dues_reports.statement",
      parent: "reports/customer-dues",
    },
    filePath: "modules/reports/components/customer-dues/statement/index",
    isModule: true,
  },
  {
    path: "reports/customer-dues/service-revenue",
    breadcrumb: {
      label: "customer_dues_reports.service_revenue",
      parent: "reports/customer-dues",
    },
    filePath: "modules/reports/components/customer-dues/service-revenue/index",
    isModule: true,
  },
  {
    path: "reports/owner-vouchers",
    filePath: "modules/reports/components/owner-vouchers/index",
    isModule: true,
  },
  {
    path: "reports/owner-vouchers/remittance-pending",
    breadcrumb: {
      label: "owner_vouchers_reports.remittance_pending",
      parent: "reports/owner-vouchers",
    },
    filePath:
      "modules/reports/components/owner-vouchers/remittance-pending/index",
    isModule: true,
  },
  {
    path: "reports/owner-vouchers/earnings-statement",
    breadcrumb: {
      label: "owner_vouchers_reports.earnings_statement",
      parent: "reports/owner-vouchers",
    },
    filePath:
      "modules/reports/components/owner-vouchers/earnings-statement/index",
    isModule: true,
  },
  {
    path: "reports/owner-vouchers/ledger",
    breadcrumb: {
      label: "owner_vouchers_reports.owner_ledger",
      parent: "reports/owner-vouchers",
    },
    filePath: "modules/reports/components/owner-vouchers/ledger/index",
    isModule: true,
  },
  {
    path: "reports/owner-vouchers/cashbook",
    breadcrumb: {
      label: "owner_vouchers_reports.cashbook",
      parent: "reports/owner-vouchers",
    },
    filePath: "modules/reports/components/owner-vouchers/cashbook/index",
    isModule: true,
  },
  {
    path: "reports/customer-dues/revenue-analysis",
    breadcrumb: {
      label: "customer_dues_reports.revenue_analysis",
      parent: "reports/customer-dues",
    },
    filePath: "modules/reports/components/customer-dues/revenue-analysis/index",
    isModule: true,
  },
  {
    path: "reports/customer-dues/overdue-by-asset",
    breadcrumb: {
      label: "customer_dues_reports.overdue_by_asset",
      parent: "reports/customer-dues",
    },
    filePath: "modules/reports/components/customer-dues/overdue-by-asset/index",
    isModule: true,
  },
  {
    path: "reports/crm-reports",
    filePath: "modules/reports/components/crm-reports/index",
    isModule: true,
  },
  {
    path: "reports/crm-reports/pipeline-funnel",
    breadcrumb: {
      label: "crm_reports.pipeline_funnel",
      parent: "reports/crm-reports",
    },
    filePath: "modules/reports/components/crm-reports/pipeline-funnel/index",
    isModule: true,
  },
  {
    path: "reports/crm-reports/lead-source-roi",
    breadcrumb: {
      label: "crm_reports.lead_source_roi",
      parent: "reports/crm-reports",
    },
    filePath: "modules/reports/components/crm-reports/lead-source-roi/index",
    isModule: true,
  },
  {
    path: "reports/crm-reports/closed-lost-reasons",
    breadcrumb: {
      label: "crm_reports.closed_lost_reasons",
      parent: "reports/crm-reports",
    },
    filePath:
      "modules/reports/components/crm-reports/closed-lost-reasons/index",
    isModule: true,
  },
  {
    path: "reports/crm-reports/agent-performance",
    breadcrumb: {
      label: "crm_reports.agent_performance",
      parent: "reports/crm-reports",
    },
    filePath: "modules/reports/components/crm-reports/agent-performance/index",
    isModule: true,
  },
  {
    path: "reports/crm-reports/match-quality",
    breadcrumb: {
      label: "crm_reports.match_quality",
      parent: "reports/crm-reports",
    },
    filePath: "modules/reports/components/crm-reports/match-quality/index",
    isModule: true,
  },
  {
    path: "reports/crm-reports/activity-aging",
    breadcrumb: {
      label: "crm_reports.activity_aging",
      parent: "reports/crm-reports",
    },
    filePath: "modules/reports/components/crm-reports/activity-aging/index",
    isModule: true,
  },
  {
    path: "reports/crm-reports/weighted-forecast",
    breadcrumb: {
      label: "crm_reports.weighted_forecast",
      parent: "reports/crm-reports",
    },
    filePath: "modules/reports/components/crm-reports/weighted-forecast/index",
    isModule: true,
  },
  {
    path: "reports/crm-reports/forecast-accuracy",
    breadcrumb: {
      label: "crm_reports.forecast_accuracy",
      parent: "reports/crm-reports",
    },
    filePath: "modules/reports/components/crm-reports/forecast-accuracy/index",
    isModule: true,
  },
  {
    path: "reports/properties",
    filePath: "modules/reports/components/properties/index",
    isModule: true,
  },
  {
    path: "reports/properties/portfolio-overview",
    breadcrumb: {
      label: "properties_reports.portfolio_overview",
      parent: "reports/properties",
    },
    filePath: "modules/reports/components/properties/portfolio-overview/index",
    isModule: true,
  },
  {
    path: "reports/properties/occupancy-status",
    breadcrumb: {
      label: "properties_reports.occupancy_status",
      parent: "reports/properties",
    },
    filePath: "modules/reports/components/properties/occupancy-status/index",
    isModule: true,
  },
  {
    path: "reports/properties/vacancy-dom",
    breadcrumb: {
      label: "properties_reports.vacancy_dom",
      parent: "reports/properties",
    },
    filePath: "modules/reports/components/properties/vacancy-dom/index",
    isModule: true,
  },
  {
    path: "reports/properties/contract-expiry",
    breadcrumb: {
      label: "properties_reports.contract_expiry",
      parent: "reports/properties",
    },
    filePath: "modules/reports/components/properties/contract-expiry/index",
    isModule: true,
  },
  {
    path: "reports/properties/sales-pipeline",
    breadcrumb: {
      label: "properties_reports.sales_pipeline",
      parent: "reports/properties",
    },
    filePath: "modules/reports/components/properties/sales-pipeline/index",
    isModule: true,
  },
  {
    path: "reports/properties/booking-performance",
    breadcrumb: {
      label: "properties_reports.booking_performance",
      parent: "reports/properties",
    },
    filePath: "modules/reports/components/properties/booking-performance/index",
    isModule: true,
  },
  {
    path: "reports/properties/marketplace-performance",
    breadcrumb: {
      label: "properties_reports.marketplace_performance",
      parent: "reports/properties",
    },
    filePath:
      "modules/reports/components/properties/marketplace-performance/index",
    isModule: true,
  },
  {
    path: "reports/properties/profitability",
    breadcrumb: {
      label: "properties_reports.profitability",
      parent: "reports/properties",
    },
    filePath: "modules/reports/components/properties/profitability/index",
    isModule: true,
  },
  {
    path: "reports/properties/owner-portfolio",
    breadcrumb: {
      label: "properties_reports.owner_portfolio",
      parent: "reports/properties",
    },
    filePath: "modules/reports/components/properties/owner-portfolio/index",
    isModule: true,
  },
  {
    path: "reports/properties/maintenance-history",
    breadcrumb: {
      label: "properties_reports.maintenance_history",
      parent: "reports/properties",
    },
    filePath: "modules/reports/components/properties/maintenance-history/index",
    isModule: true,
  },
  {
    path: "reports/properties/project-profitability",
    breadcrumb: {
      label: "properties_reports.project_profitability",
      parent: "reports/properties",
    },
    filePath:
      "modules/reports/components/properties/project-profitability/index",
    isModule: true,
  },
  {
    path: "reports/rent",
    filePath: "modules/reports/components/rent/index",
    isModule: true,
  },
  {
    path: "reports/rent/active-rent-roll",
    breadcrumb: {
      label: "rent_reports.active_rent_roll",
      parent: "reports/rent",
    },
    filePath: "modules/reports/components/rent/active-rent-roll/index",
    isModule: true,
  },
  {
    path: "reports/rent/lifecycle-funnel",
    breadcrumb: {
      label: "rent_reports.lifecycle_funnel",
      parent: "reports/rent",
    },
    filePath: "modules/reports/components/rent/lifecycle-funnel/index",
    isModule: true,
  },
  {
    path: "reports/rent/renewal-forecast",
    breadcrumb: {
      label: "rent_reports.renewal_forecast",
      parent: "reports/rent",
    },
    filePath: "modules/reports/components/rent/renewal-forecast/index",
    isModule: true,
  },
  {
    path: "reports/rent/terminations-analysis",
    breadcrumb: {
      label: "rent_reports.terminations_analysis",
      parent: "reports/rent",
    },
    filePath: "modules/reports/components/rent/terminations-analysis/index",
    isModule: true,
  },
  {
    path: "reports/rent/ejar-status",
    breadcrumb: { label: "rent_reports.ejar_status", parent: "reports/rent" },
    filePath: "modules/reports/components/rent/ejar-status/index",
    isModule: true,
  },
  {
    path: "reports/sales",
    filePath: "modules/reports/components/sales/index",
    isModule: true,
  },
  {
    path: "reports/sales/price-quotations-register",
    breadcrumb: {
      label: "sales_reports.quotations_register",
      parent: "reports/sales",
    },
    filePath: "modules/reports/components/sales/quotations-register/index",
    isModule: true,
    permissionId: SALES_REPORTS_QUOTATIONS_REGISTER,
  },
  {
    path: "reports/sales/price-quotation-conversion",
    breadcrumb: {
      label: "sales_reports.quotation_conversion",
      parent: "reports/sales",
    },
    filePath: "modules/reports/components/sales/quotation-conversion/index",
    isModule: true,
    permissionId: SALES_REPORTS_QUOTATION_CONVERSION,
  },
  {
    path: "reports/sales/invoice-analysis",
    breadcrumb: {
      label: "sales_reports.invoice_analysis",
      parent: "reports/sales",
    },
    filePath: "modules/reports/components/sales/invoice-analysis/index",
    isModule: true,
    permissionId: SALES_REPORTS_INVOICE_ANALYSIS,
  },
  {
    path: "reports/purchases",
    filePath: "modules/reports/components/purchases/index",
    isModule: true,
  },
  {
    path: "reports/purchases/invoice-analysis",
    breadcrumb: {
      label: "purchases_reports.invoice_analysis",
      parent: "reports/purchases",
    },
    filePath: "modules/reports/components/purchases/invoice-analysis/index",
    isModule: true,
  },
  {
    path: "reports/purchases/expenses-analysis",
    breadcrumb: {
      label: "purchases_reports.expenses_analysis",
      parent: "reports/purchases",
    },
    filePath: "modules/reports/components/purchases/expenses-analysis/index",
    isModule: true,
  },
  {
    path: "reports/sell",
    filePath: "modules/reports/components/sell/index",
    isModule: true,
  },
  {
    path: "reports/sell/sales-pipeline",
    breadcrumb: {
      label: "sell_reports.sales_pipeline",
      parent: "reports/sell",
    },
    filePath: "modules/reports/components/sell/sales-pipeline/index",
    isModule: true,
  },
  {
    path: "reports/sell/installments-schedule",
    breadcrumb: {
      label: "sell_reports.installments_schedule",
      parent: "reports/sell",
    },
    filePath: "modules/reports/components/sell/installments-schedule/index",
    isModule: true,
  },
  {
    path: "reports/sell/cancellations-analysis",
    breadcrumb: {
      label: "sell_reports.cancellations_analysis",
      parent: "reports/sell",
    },
    filePath: "modules/reports/components/sell/cancellations-analysis/index",
    isModule: true,
  },
  {
    path: "reports/sell/discount-analysis",
    breadcrumb: {
      label: "sell_reports.discount_analysis",
      parent: "reports/sell",
    },
    filePath: "modules/reports/components/sell/discount-analysis/index",
    isModule: true,
  },
  {
    path: "reports/booking",
    filePath: "modules/reports/components/booking/index",
    isModule: true,
  },
  {
    path: "reports/booking/calendar-heatmap",
    breadcrumb: {
      label: "booking_reports.calendar_heatmap",
      parent: "reports/booking",
    },
    filePath: "modules/reports/components/booking/calendar-heatmap/index",
    isModule: true,
  },
  {
    path: "reports/booking/utilization-revpar",
    breadcrumb: {
      label: "booking_reports.utilization_revpar",
      parent: "reports/booking",
    },
    filePath: "modules/reports/components/booking/utilization-revpar/index",
    isModule: true,
  },
  {
    path: "reports/booking/blackout-impact",
    breadcrumb: {
      label: "booking_reports.blackout_impact",
      parent: "reports/booking",
    },
    filePath: "modules/reports/components/booking/blackout-impact/index",
    isModule: true,
  },
];

//////////////// Misc ////////////////
const miscRoutes = [
  {
    path: "access-denied",
    breadcrumb: { label: "breadcrumbs.accessDenied" },
    filePath: "modules/access-denied/components/index",
    isModule: true,
  },
  {
    path: "module-not-available",
    breadcrumb: { label: "breadcrumbs.moduleNotAvailable" },
    filePath: "modules/module-not-available/components/index",
    isModule: true,
    skipPermissionGate: true,
  },
  {
    path: "not-found",
    breadcrumb: { label: "breadcrumbs.notFound" },
    filePath: "modules/not-found/components/index",
    isModule: true,
    skipPermissionGate: true,
  },
  {
    path: "form",
    breadcrumb: { label: "breadcrumbs.form" },
    filePath: "modules/form/components/index",
    isModule: true,
  },
  {
    path: "make-promotion/:id",
    breadcrumb: { label: "promotions.add", parent: "units/:id" },
    filePath: "modules/promotions/components/index",
    isModule: true,
  },
  {
    path: "spareparts-requests",
    filePath: "modules/maintenance/components/spareparts/components/index",
    isModule: true,
    permissionId: SPARE_PARTS_REQUESTS_INDEX,
  },

  // System administrators (under auth)
  {
    path: "admins",
    filePath: "modules/auth/components/system-administrators/index",
    isModule: true,
    permissionId: ADMINS_INDEX,
  },
  {
    path: "admins/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "admins" },
    filePath: "modules/auth/components/system-administrators/add-admin/index",
    isModule: true,
    createPermissionId: ADMINS_CREATE,
    editPermissionId: ADMINS_EDIT,
  },
  {
    path: "admins/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "admins" },
    filePath:
      "modules/auth/components/system-administrators/admin-profile/index",
    isModule: true,
    permissionId: ADMINS_SHOW,
  },
  {
    path: "admins/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "admins/:id" },
    filePath: "modules/auth/components/system-administrators/add-admin/index",
    isModule: true,
    createPermissionId: ADMINS_CREATE,
    editPermissionId: ADMINS_EDIT,
  },
  {
    path: "update-profile/:id",
    breadcrumb: { label: "pages.editProfile", parent: "profile" },
    filePath: "modules/auth/components/system-administrators/add-admin/index",
    isModule: true,
    skipPermissionGate: true,
  },
];

//////////////// Wallet ////////////////
const walletRoutes = [
  {
    path: "wallet",
    breadcrumb: { label: "wallet.pageTitle" },
    filePath: "modules/wallet/components/index",
    isModule: true,
    permissionId: WALLET_INDEX,
  },
  {
    path: "wallet/settings",
    breadcrumb: { label: "wallet.settingsPage.title", parent: "wallet" },
    filePath: "modules/wallet/components/settings/index",
    isModule: true,
    permissionId: WALLET_SETTINGS,
  },
];

//////////////// Dues - Modules ////////////////
const duesRoutes = [
  {
    path: "dues",
    breadcrumb: { label: "pages.dues" },
    filePath: "modules/dues/pages/List",
    isModule: true,
  },
];

//////////////// Subscriptions - Modules ////////////////
const subscriptionsRoutes = [
  {
    path: "subscriptions",
    breadcrumb: { label: "subscriptions.title" },
    filePath: "modules/subscriptions/pages/ViewPage",
    isModule: true,
    permissionId: SUBSCRIPTIONS_INDEX,
  },
];

//////////////// Home - Modules ////////////////
const homeRoutes = [
  {
    path: "home",
    breadcrumb: { label: "breadcrumbs.home" },
    filePath: "modules/home/components/index",
    isModule: true,
    permissionId: HOME_INDEX,
  },
  {
    path: "financial-overview",
    breadcrumb: {
      label: "financialOverview.title",
      parent: "overview/finance",
    },
    filePath: "modules/financial-overview/components/index",
    isModule: true,
    permissionId: FINANCIAL_REPORTS_EXECUTIVE_OVERVIEW,
  },
];

//////////////// Module Overview (cockpit) pages ////////////////
const overviewRoutes = [
  {
    path: "overview/properties",
    filePath: "modules/overview/components/properties/index",
    isModule: true,
    permissionId: OVERVIEW_PROPERTIES_INDEX,
  },
  {
    path: "overview/finance",
    filePath: "modules/overview/components/finance/index",
    isModule: true,
    permissionId: OVERVIEW_FINANCE_INDEX,
  },
  {
    path: "overview/inventory",
    filePath: "modules/overview/components/inventory/index",
    isModule: true,
    permissionId: OVERVIEW_INVENTORY_INDEX,
  },
  {
    path: "overview/maintenance",
    filePath: "modules/overview/components/maintenance/index",
    isModule: true,
    permissionId: OVERVIEW_MAINTENANCE_INDEX,
  },
  {
    path: "overview/customers",
    filePath: "modules/overview/components/customers/index",
    isModule: true,
    permissionId: OVERVIEW_CUSTOMERS_INDEX,
  },
  {
    path: "overview/documents",
    filePath: "modules/overview/components/documents/index",
    isModule: true,
    permissionId: OVERVIEW_DOCUMENTS_INDEX,
  },
  {
    path: "overview/hr",
    filePath: "modules/overview/components/hr/index",
    isModule: true,
    // Gated by the employees register — the page is a view over registers that
    // permission already opens (no dedicated overview.hr key yet), and each
    // section is separately gated server-side on its own module permission.
    permissionId: EMPLOYEES_INDEX,
  },
  {
    path: "overview/letters",
    filePath: "modules/overview/components/letters/index",
    isModule: true,
    // Gated by the register permission — the page is a view over the letters
    // the caller can already list (no dedicated overview.letters key yet).
    permissionId: LETTERS_INDEX,
  },
];

//////////////// Profile ////////////////
const profileRoutes = [
  {
    path: "profile",
    breadcrumb: { label: "pages.profile" },
    filePath: "modules/auth/components/profile/index",
    isModule: true,
  },
];

//////////////// Investment Management ////////////////
const investmentManagementRoutes = [
  {
    path: "units/:id/investment-management/:tab",
    breadcrumb: {
      label: "breadcrumbs.investmentManagement",
      parent: "units/:id",
    },
    filePath:
      "modules/units/components/unit-profile/investment-management/index",
    isModule: true,
    permissionId: UNIT_INVESTMENT_SUMMARY,
  },
  {
    path: "investment-management/parties/add",
    breadcrumb: {
      label: "unitInvestment.partyForm.addTitle",
      parent: "units-and-properties?view=unit",
    },
    filePath:
      "modules/units/components/unit-profile/investment-management/tabs/parties/add/index",
    isModule: true,
    createPermissionId: UNIT_PARTIES_STORE,
    editPermissionId: UNIT_PARTIES_UPDATE,
  },
  {
    path: "investment-management/parties/:id/edit",
    breadcrumb: {
      label: "unitInvestment.partyForm.editTitle",
      parent: "units-and-properties?view=unit",
    },
    filePath:
      "modules/units/components/unit-profile/investment-management/tabs/parties/add/index",
    isModule: true,
    createPermissionId: UNIT_PARTIES_STORE,
    editPermissionId: UNIT_PARTIES_UPDATE,
  },
  {
    path: "investment-management/parties/:id",
    breadcrumb: {
      label: "unitInvestment.partyForm.viewTitle",
      parent: "units-and-properties?view=unit",
    },
    filePath:
      "modules/units/components/unit-profile/investment-management/tabs/parties/add/index",
    isModule: true,
    permissionId: UNIT_PARTIES_SHOW,
  },
];

const siteVisitBookingRoutes = [
  {
    path: "site-visit-booking",
    filePath: "modules/site-visit-booking/components/index",
    isModule: true,
    permissionId: SITE_VISITS_INDEX,
  },
  // The Settings hub's Site Visit Settings tab, reached from the workspace
  // header — under this module in the trail, so Back returns to Site Visits.
  {
    path: "site-visit-booking/settings",
    breadcrumb: {
      label: "settingsSidebar.siteVisitSettings",
      parent: "site-visit-booking",
    },
    filePath: "modules/site-visit-booking/components/settings-page",
    isModule: true,
    permissionId: SITE_VISITS_SETTINGS_INDEX,
  },
];
//////////////// Appointment Bookings ////////////////
const appointmentBookingsRoutes = [
  {
    path: "appointment-bookings",
    filePath: "modules/appointment-bookings/components/index",
    isModule: true,
    permissionId: APPOINTMENT_BOOKINGS_INDEX,
  },
];
//////////////// Service requests (marketing website) ////////////////
// `service-requests.index` also covers the detail drawer — there is no `show` key.
const serviceRequestsRoutes = [
  {
    path: "service-requests",
    filePath: "modules/service-requests/components/index",
    isModule: true,
    permissionId: SERVICE_REQUESTS_INDEX,
  },
];
//////////////// Finance close & control ////////////////
const accountingPeriodsRoutes = [
  {
    path: "accounting-periods",
    filePath: "modules/accounting-periods/components/index",
    isModule: true,
    permissionId: ACCOUNTING_PERIODS_INDEX,
  },
  {
    path: "fiscal-year-closings",
    filePath:
      "modules/accounting-periods/components/fiscal-year-closings/index",
    isModule: true,
    permissionId: FISCAL_YEAR_CLOSINGS_INDEX,
  },
  // Guarded by the register's own index: there is no fiscal_year_closings.show
  // key, and whoever may list the closings may open one (backend rule 5).
  {
    path: "fiscal-year-closings/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "fiscal-year-closings" },
    filePath: "modules/accounting-periods/components/closing-view/index",
    isModule: true,
    permissionId: FISCAL_YEAR_CLOSINGS_INDEX,
  },
];

const openingBalancesRoutes = [
  {
    path: "opening-balances/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "opening-balances" },
    filePath: "modules/opening-balances/components/add-opening-balance/index",
    isModule: true,
    createPermissionId: OPENING_BALANCES_IMPORT,
    editPermissionId: OPENING_BALANCES_IMPORT,
  },
  {
    path: "opening-balances/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "opening-balances/:id" },
    filePath: "modules/opening-balances/components/add-opening-balance/index",
    isModule: true,
    createPermissionId: OPENING_BALANCES_IMPORT,
    editPermissionId: OPENING_BALANCES_IMPORT,
  },
  {
    path: "opening-balances/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "opening-balances" },
    filePath: "modules/opening-balances/components/opening-balance-view/index",
    isModule: true,
    permissionId: OPENING_BALANCES_INDEX,
  },
  {
    path: "opening-balances",
    filePath: "modules/opening-balances/components/index",
    isModule: true,
    permissionId: OPENING_BALANCES_INDEX,
  },
];

const recurringJournalsRoutes = [
  {
    path: "recurring-journals/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "recurring-journals" },
    filePath:
      "modules/recurring-journals/components/add-recurring-journal/index",
    isModule: true,
    createPermissionId: RECURRING_JOURNALS_CREATE,
    editPermissionId: RECURRING_JOURNALS_UPDATE,
  },
  {
    path: "recurring-journals/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "recurring-journals/:id" },
    filePath:
      "modules/recurring-journals/components/add-recurring-journal/index",
    isModule: true,
    createPermissionId: RECURRING_JOURNALS_CREATE,
    editPermissionId: RECURRING_JOURNALS_UPDATE,
  },
  {
    path: "recurring-journals/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "recurring-journals" },
    filePath:
      "modules/recurring-journals/components/recurring-journal-view/index",
    isModule: true,
    permissionId: RECURRING_JOURNALS_INDEX,
  },
  {
    path: "recurring-journals",
    filePath: "modules/recurring-journals/components/index",
    isModule: true,
    permissionId: RECURRING_JOURNALS_INDEX,
  },
];

const deferralSchedulesRoutes = [
  {
    path: "deferral-schedules/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "deferral-schedules" },
    filePath:
      "modules/deferral-schedules/components/add-deferral-schedule/index",
    isModule: true,
    createPermissionId: DEFERRAL_SCHEDULES_CREATE,
    editPermissionId: DEFERRAL_SCHEDULES_UPDATE,
  },
  {
    path: "deferral-schedules/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "deferral-schedules/:id" },
    filePath:
      "modules/deferral-schedules/components/add-deferral-schedule/index",
    isModule: true,
    createPermissionId: DEFERRAL_SCHEDULES_CREATE,
    editPermissionId: DEFERRAL_SCHEDULES_UPDATE,
  },
  {
    path: "deferral-schedules/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "deferral-schedules" },
    filePath:
      "modules/deferral-schedules/components/deferral-schedule-view/index",
    isModule: true,
    permissionId: DEFERRAL_SCHEDULES_INDEX,
  },
  {
    path: "deferral-schedules",
    filePath: "modules/deferral-schedules/components/index",
    isModule: true,
    permissionId: DEFERRAL_SCHEDULES_INDEX,
  },
];

const fixedAssetsRoutes = [
  {
    path: "fixed-assets/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "fixed-assets" },
    filePath: "modules/fixed-assets/components/add-fixed-asset/index",
    isModule: true,
    createPermissionId: FIXED_ASSETS_CREATE,
    editPermissionId: FIXED_ASSETS_UPDATE,
  },
  {
    path: "fixed-assets/:id/edit",
    breadcrumb: { label: "breadcrumbs.edit", parent: "fixed-assets/:id" },
    filePath: "modules/fixed-assets/components/add-fixed-asset/index",
    isModule: true,
    createPermissionId: FIXED_ASSETS_CREATE,
    editPermissionId: FIXED_ASSETS_UPDATE,
  },
  // Declared before "fixed-assets/:id" so the literal segment is not swallowed
  // by the id param.
  {
    path: "fixed-assets/depreciation-runs",
    breadcrumb: { label: "fixedAssets.runs.title", parent: "fixed-assets" },
    filePath: "modules/fixed-assets/components/depreciation-runs/index",
    isModule: true,
    permissionId: FIXED_ASSETS_INDEX,
  },
  {
    path: "fixed-assets/depreciation-runs/:id",
    breadcrumb: {
      label: "breadcrumbs.record",
      parent: "fixed-assets/depreciation-runs",
    },
    filePath: "modules/fixed-assets/components/depreciation-run-view/index",
    isModule: true,
    permissionId: FIXED_ASSETS_INDEX,
  },
  {
    path: "fixed-assets/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "fixed-assets" },
    filePath: "modules/fixed-assets/components/fixed-asset-view/index",
    isModule: true,
    permissionId: FIXED_ASSETS_INDEX,
  },
  {
    path: "fixed-assets",
    filePath: "modules/fixed-assets/components/index",
    isModule: true,
    permissionId: FIXED_ASSETS_INDEX,
  },
];

const bankReconciliationsRoutes = [
  {
    path: "bank-reconciliations/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "bank-reconciliations" },
    filePath:
      "modules/bank-reconciliations/components/add-bank-reconciliation/index",
    isModule: true,
    createPermissionId: BANK_RECONCILIATIONS_CREATE,
    editPermissionId: BANK_RECONCILIATIONS_UPDATE,
  },
  {
    path: "bank-reconciliations/:id/edit",
    breadcrumb: {
      label: "breadcrumbs.edit",
      parent: "bank-reconciliations/:id",
    },
    filePath:
      "modules/bank-reconciliations/components/add-bank-reconciliation/index",
    isModule: true,
    createPermissionId: BANK_RECONCILIATIONS_CREATE,
    editPermissionId: BANK_RECONCILIATIONS_UPDATE,
  },
  {
    path: "bank-reconciliations/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "bank-reconciliations" },
    filePath:
      "modules/bank-reconciliations/components/bank-reconciliation-view/index",
    isModule: true,
    permissionId: BANK_RECONCILIATIONS_INDEX,
  },
  {
    path: "bank-reconciliations",
    filePath: "modules/bank-reconciliations/components/index",
    isModule: true,
    permissionId: BANK_RECONCILIATIONS_INDEX,
  },
];

const provisionsRoutes = [
  {
    path: "doubtful-debt-provisions/new",
    breadcrumb: {
      label: "breadcrumbs.new",
      parent: "doubtful-debt-provisions",
    },
    filePath:
      "modules/provisions/components/doubtful-debt-provisions/run-provision/index",
    isModule: true,
    permissionId: DOUBTFUL_DEBT_PROVISIONS_POST,
  },
  {
    path: "doubtful-debt-provisions/:id",
    breadcrumb: {
      label: "breadcrumbs.record",
      parent: "doubtful-debt-provisions",
    },
    filePath:
      "modules/provisions/components/doubtful-debt-provisions/provision-view/index",
    isModule: true,
    permissionId: DOUBTFUL_DEBT_PROVISIONS_INDEX,
  },
  {
    path: "doubtful-debt-provisions",
    filePath: "modules/provisions/components/doubtful-debt-provisions/index",
    isModule: true,
    permissionId: DOUBTFUL_DEBT_PROVISIONS_INDEX,
  },
  {
    path: "receivable-writeoffs/new",
    breadcrumb: { label: "breadcrumbs.new", parent: "receivable-writeoffs" },
    filePath:
      "modules/provisions/components/receivable-writeoffs/add-receivable-writeoff/index",
    isModule: true,
    permissionId: RECEIVABLE_WRITEOFFS_CREATE,
  },
  {
    path: "receivable-writeoffs/:id",
    breadcrumb: { label: "breadcrumbs.record", parent: "receivable-writeoffs" },
    filePath:
      "modules/provisions/components/receivable-writeoffs/writeoff-view/index",
    isModule: true,
    permissionId: RECEIVABLE_WRITEOFFS_INDEX,
  },
  {
    path: "receivable-writeoffs",
    filePath: "modules/provisions/components/receivable-writeoffs/index",
    isModule: true,
    permissionId: RECEIVABLE_WRITEOFFS_INDEX,
  },
];

export const protectedRoutes = [
  ...homeRoutes,
  ...overviewRoutes,
  ...siteVisitBookingRoutes,
  ...appointmentBookingsRoutes,
  ...serviceRequestsRoutes,
  ...profileRoutes,
  ...banksRoutes,
  ...contractsRoutes,
  ...customersRoutes,
  ...employeesRoutes,
  ...entitiesRoutes,
  ...financialRoutes,
  ...inventoryRoutes,
  ...invoicesRoutes,
  ...priceQuotationsRoutes,
  ...serviceContractsRoutes,
  ...payrollRoutes,
  ...endOfServiceRoutes,
  ...attendanceRoutes,
  ...hrReportsRoutes,
  ...bookingContractsRoutes,
  ...ejarContractsRoutes,
  ...documentsRoutes,
  ...lettersRoutes,
  ...esignRoutes,
  ...maintenanceRoutes,
  ...crmRoutes,
  ...propertiesRoutes,
  ...projectsRoutes,
  ...unitsRoutes,
  ...rolesRoutes,
  ...sanadatRoutes,
  ...servicesRoutes,
  ...settingsRoutes,
  ...supportRoutes,
  ...amerSupportRoutes,
  ...actionLogsRoutes,
  ...announcementsRoutes,
  ...advertisementsRoutes,
  ...taxesRoutes,
  ...stockWithdrawRequestsRoutes,
  ...warehousesRoutes,
  ...posRoutes,
  ...tasksRoutes,
  ...notesRoutes,
  ...ordersRoutes,
  ...reportsRoutes,
  ...walletRoutes,
  ...duesRoutes,
  ...subscriptionsRoutes,
  ...miscRoutes,
  ...investmentManagementRoutes,
  ...notificationTemplatesRoutes,
  ...notificationsRoutes,
  ...accountingPeriodsRoutes,
  ...openingBalancesRoutes,
  ...recurringJournalsRoutes,
  ...deferralSchedulesRoutes,
  ...fixedAssetsRoutes,
  ...bankReconciliationsRoutes,
  ...provisionsRoutes,
];
